import {
	createContext,
	useContext,
	useState,
	useEffect,
	useCallback,
} from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { baseUrl } from "../utils/OtherUtils";
import { useAuthContext } from "./AuthContext";
import { useProfileContext } from "./ProfileContext";
import { useNavigate } from "react-router-dom";

export const OrderProcessingContext = createContext();

const OrderProcessingProvider = ({ children }) => {
	const {
		setIsAuth,
		isLoggedIn,
		handleNotification,
		setUserLocation,
		userLocation,
	} = useAuthContext();
	const { userProfile } = useProfileContext();
	const navigate = useNavigate();

	// Save order on localStorage
	const saveOrderToLocalStorage = (order) => {
		localStorage.setItem("finelabsOrder", JSON.stringify(order));
	};

	// Get order from localStorage
	// const getOrderFromLocalStorage = () => {
	// 	const storedOrder = localStorage.getItem("finelabsOrder");
	// 	return storedOrder ? JSON.parse(storedOrder) : null;
	// };

	const getOrderFromLocalStorage = () => {
		try {
			const raw = localStorage.getItem("finelabsOrder");
			return raw ? JSON.parse(raw) : null;
		} catch {
			return null;
		}
	};

	const [order, setOrder] = useState(() => {
		const savedOrder = getOrderFromLocalStorage();
		return (
			savedOrder || {
				orderId: "",
				userDetails: { name: "", contact: "", email: "" },
				orderData: [],
				address: {},
				freeTest: {
					name: "",
					brand: "",
					price: "",
				},
				matchedFreeTest: {
					name: "",
					brand: "",
					price: "",
				},
				paymentDetails: {
					currency: "₹",
					totalPrice: "",
					totalCartValue: "",
					totalDiscountPrice: "",
					finalAmount: "",
					collectionCharges: "",
					freeChargeDifference: "",
					freeTestsTotalMRP: "",
					matchedFreeTest: "",
					freeTest: "",
					discount: "",
					platformFee: "",
				},
				collectionMode: "",
				visitCenter: "",
				centerCode: "",
				collectionDate: { date: {}, time: "" },
				visitDate: { date: {}, time: "" },
				geoLocation: { longitude: "", latitude: "" },
				status: "Pending",
				appliedPromoCode: "",
			}
		);
	});

	const [indexToAddPatient, setIndexToAddPatient] = useState(null);
	const [isAddMemberPopup, setIsAddMemberPopup] = useState(false);
	const [isAddAddressPopup, setIsAddAddressPopup] = useState(false);
	const [serviceableArea, setServiceableArea] = useState({
		flag: null,
		message: "",
	});
	const [centreAvailable, setCentreAvailable] = useState({
		flag: null,
		message: "",
	});
	const [isPromoCode, setIsPromoCode] = useState(false);
	const [promoCode, setPromoCode] = useState("");
	const [promoCodeMessage, setPromoCodeMessage] = useState({
		flag: null,
		message: "",
	});
	const [orderSummary, setOrderSummary] = useState({});
	const currency = "INR";
	const receipt = "receipt_#0";
	const [isPaymentDone, setIsPaymentDone] = useState(false);
	const [allOrders, setAllOrders] = useState([]);
	const [addMoreTestIndex, setAddMoreTestIndex] = useState();
	const [allCentres, setAllCentres] = useState([]);

	// const [collectionType, setCollectionType] = useState("Home");
	const [collectionType, setCollectionType] = useState("Visit");

	const getUserIdFromOrder = () => {
		try {
			const raw = localStorage.getItem("finelabsOrder");
			if (!raw) return null;
			const parsed = JSON.parse(raw);
			return parsed?.userId || null; // assuming finelabsOrder has userId
		} catch {
			return null;
		}
	};

	const userId = getUserIdFromOrder();  // get it once here

	// 	useEffect(() => {
	// 		if (!userId) return;
	// // api/collectionType/get-collectionType
	// 		axios
	// 			.get(`http://localhost:5000/api/collectionType/get-collectionType/${userId}`)
	// 			.then((res) => {
	// 				if (res.data?.collectionType) {
	// 					setCollectionType(res.data.collectionType);
	// 				}
	// 				console.log("Collection Type:", collectionType);
	// 			})
	// 			.catch((err) => {
	// 				console.error("Error fetching collection type:", err);
	// 			});
	// 	}, [userId]);

	// 	const handleAddCartCollectionType = async (type) => {
	// 		console.log("handleAddCartColl", type);
	// 		setCollectionType(type);
	// 		try {

	// 			await axios.post("http://localhost:5000/api/collectionType/add-collectionType", {
	// 				userId,
	// 				collectionType: type,
	// 			});
	// 		} catch (err) {
	// 			console.error("Error updating:", err);
	// 		}
	// 	};


	// console.log("freeTest line 154", order?.freeTest);
	useEffect(() => {
		const savedType = localStorage.getItem("collectionType");
		if (savedType) {
			setCollectionType(savedType);
		}
	}, []);

	// Save to localStorage whenever it changes
	useEffect(() => {
		localStorage.setItem("collectionType", collectionType);
	}, [collectionType]);

	const [isCollectionMethodPopup, setIsCollectionMethodPopup] = useState(false);



	// Update localStorage whenever `order` changes
	useEffect(() => {
		saveOrderToLocalStorage(order);
	}, [order]);


	// inside context or wherever you manage notification state
	// const handleNotification = (type, message, position = "bottom-right") => {
	// 	setNotificationData({ type, message, position });
	// };

	// Add a product to the items array of all objects in orderData
	const addProductToCart = (product) => {
		if (!isLoggedIn) {
			setIsAuth(true);
			return;
		}

		// Check if any product already exists
		const existingBrand = order.orderData
			.flatMap((entry) => entry.items.map((item) => item.product.brandName))
			.find((brandName) => brandName); // Get the brandName of the first product if any

		// Validate brandName if there's already a product in the cart
		if (existingBrand && existingBrand !== product.brandName) {
			handleNotification(
				false,
				// `You can only add products from the ${existingBrand}`
				"Please add products of a single brand at a time, To avoid multiple sample collection."
			);
			return;
		}
		// else if (product.brandName === 'Dr Lal PathLabs') {
		// 	handleNotification(
		// 		"info",
		// 		"💡 Dr. Lal PathLabs services are paused for now. Don’t worry—you can still book tests from our other trusted partners.",
		// 		"center"   //position
		// 	);
		// 	return;

		// }

		const updatedOrder = {
			...order,
			orderData:
				Array.isArray(order.orderData) && order.orderData.length > 0
					? order.orderData.map((entry, index) => {
						// console.log("insideUpdatedOrder", entry);

						if (addMoreTestIndex !== null && addMoreTestIndex !== undefined) {
							// Add only to the specific index

							return index === addMoreTestIndex
								? {
									...entry,

									items: [
										...entry.items,

										{ product, discountPrice: "", discountPercentage: "" },
									],
								}
								: entry;
						}

						// If addMoreTestIndex is null/undefined, add to all entries

						return {
							...entry,

							items: [
								...entry.items,

								{ product, discountPrice: "", discountPercentage: "" },
							],
						};
					})
					: [
						// If orderData is empty or undefined, create a new entry

						{
							items: [{ product, discountPrice: "", discountPercentage: "" }],
						},
					], // Initialize orderData with a new entry if it's empty
		};

		setOrder(updatedOrder);
		setAddMoreTestIndex();
	};

	// Add multiple products to the items array of all objects in orderData
	const addProductsToCart = (products) => {
		if (!isLoggedIn) {
			setIsAuth(true);
			return;
		}

		if (!Array.isArray(products) || products.length === 0) {
			handleNotification(false, "No products to add");
			return;
		}

		// Check if any product already exists
		const existingBrand = order.orderData
			.flatMap((entry) => entry.items.map((item) => item.product.brandName))
			.find((brandName) => brandName); // Get the brandName of the first product if any

		// Get the brandName of the first product in the array to add
		const incomingBrand = products[0].brandName;

		// Validate that all products in the array have the same brandName
		const allSameBrand = products.every(
			(product) => product.brandName === incomingBrand
		);

		if (!allSameBrand) {
			handleNotification(
				false,
				"Please add products of a single brand at a time, to avoid multiple sample collection."
			);
			return;
		}

		// Validate brandName if there's already a product in the cart
		if (existingBrand && existingBrand !== incomingBrand) {
			handleNotification(
				false,
				"Please add products of a single brand at a time, to avoid multiple sample collection."
			);
			return;
		}

		const updatedOrder = {
			...order,
			orderData:
				Array.isArray(order.orderData) && order.orderData.length > 0
					? order.orderData.map((entry, index) => {
						if (addMoreTestIndex !== null && addMoreTestIndex !== undefined) {
							// Add only to the specific index
							return index === addMoreTestIndex
								? {
									...entry,
									items: [
										...entry.items,
										...products.map((product) => ({
											product,
											discountPrice: "",
											discountPercentage: "",
										})),
									],
								}
								: entry;
						}

						// If addMoreTestIndex is null/undefined, add to all entries
						return {
							...entry,
							items: [
								...entry.items,
								...products.map((product) => ({
									product,
									discountPrice: "",
									discountPercentage: "",
								})),
							],
						};
					})
					: [
						// If orderData is empty or undefined, create a new entry
						{
							items: products.map((product) => ({
								product,
								discountPrice: "",
								discountPercentage: "",
							})),
						},
					],
		};

		setOrder(updatedOrder);
		setAddMoreTestIndex();
	};

	// Add new member object in the orderData
	const addANewMember = () => {
		if (order.orderData.length === 0) return;

		const firstObject = order.orderData[0];

		const filteredItems = firstObject.items.filter(
			(item) => item.product && Object.keys(item.product).length > 0
		);

		const newObject = { patient: {}, items: [...filteredItems] };

		const updatedOrder = {
			...order,
			orderData: [...order.orderData, newObject],
		};

		setOrder(updatedOrder);
	};

	// Remove product by id in orderData
	const removeProductById = (productId) => {
		const updatedOrder = {
			...order,
			orderData: order.orderData.map((entry) => ({
				...entry,
				items: entry.items.filter((item) => item?.product?._id !== productId),
			})),
		};

		setOrder(updatedOrder);
	};

	// Remove multiple products by their IDs in orderData
	const removeProductsById = (productIds) => {
		if (!Array.isArray(productIds) || productIds.length === 0) {
			return;
		}
		const updatedOrder = {
			...order,
			orderData: order.orderData.map((entry) => ({
				...entry,
				items: entry.items.filter(
					(item) => !productIds.includes(item?.product?._id)
				),
			})),
		};

		setOrder(updatedOrder);
	};

	// Add patient/member to the correct index on orderData
	const updatePatientAtIndex = (patient) => {
		const updatedOrder = {
			...order,
			orderData: order.orderData.map((entry, i) =>
				i === indexToAddPatient
					? {
						...entry,
						patient: { ...entry.patient, ...patient },
					}
					: entry
			),
		};

		setOrder(updatedOrder);
		setIsAddMemberPopup(false);
	};

	// Remove patient/member from the correct index on orderData
	const removePatientAtIndex = (index) => {
		const updatedOrder = {
			...order,
			orderData: order.orderData.map((entry, i) =>
				i === index
					? {
						...entry,
						patient: {},
					}
					: entry
			),
		};

		setOrder(updatedOrder);
	};

	// Remove specific product from orderData
	// const removeSpecificProduct = (orderDataIndex, itemIndex) => {
	// 	const updatedOrder = {
	// 		...order,
	// 		orderData: order.orderData.map((entry, i) =>
	// 			i === orderDataIndex
	// 				? {
	// 					...entry,
	// 					items: entry.items.filter((_, idx) => idx !== itemIndex),
	// 				}
	// 				: entry
	// 		),
	// 	};

	// 	setOrder(updatedOrder);
	// };


	// remove specific product from cart and only one selection in home and visit date and time
	const removeSpecificProduct = (orderDataIndex, itemIndex) => {
		const updatedOrderData = order.orderData.map((entry, i) =>
			i === orderDataIndex
				? {
					...entry,
					items: entry.items.filter((_, idx) => idx !== itemIndex),
				}
				: entry
		);

		const hasRadiology = updatedOrderData?.some((orderItem) =>
			orderItem.items.some((item) => item.product?.productType === "Radiology")
		);

		const hasOtherThanRadiology = updatedOrderData?.some((orderItem) =>
			orderItem.items.some((item) => item.product?.productType !== "Radiology")
		);

		let resetFields = {};
		//  If Radiology removed and only Other tests left → reset Visit
		if (!hasRadiology && hasOtherThanRadiology) {
			resetFields = { visitDate: { date: {}, time: "" } };
		}
		//  If only Radiology left → reset Home
		else if (hasRadiology && !hasOtherThanRadiology) {
			resetFields = { collectionDate: { date: {}, time: "" } };
		}
		//  If cart is empty → reset both
		else if (!hasRadiology && !hasOtherThanRadiology) {
			resetFields = { visitDate: { date: {}, time: "" }, collectionDate: { date: {}, time: "" } };
		}

		const updatedOrder = {
			...order,
			orderData: updatedOrderData,
			...resetFields, // apply reset depending on condition
		};

		setOrder(updatedOrder);
	};

	// Count all the products available in cart
	const isEmpty = (obj) => Object.keys(obj).length === 0;
	const countAllCartProducts = () =>
		order?.orderData?.reduce(
			(count, order) =>
				count + order.items.filter((item) => !isEmpty(item.product)).length,
			0
		);



	// Add address to order
	// const updateAddress = async (newAddress) => {
	// 	if (order.orderData[0].items[0].product.brandName === "Redcliffe Labs") {
	// 		// console.log("Redcliffe Labs address update");
	// 		try {
	// 			const response = await axios.post(
	// 				`${baseUrl}/api/labs/get-redcliffe-location-status`,
	// 				{
	// 					place_query: newAddress.area,
	// 				}
	// 			);

	// 			console.log("Redcliffe location status:", response.data);

	// 			// You might use this response to update order
	// 			const updatedOrder = {
	// 				...order,
	// 				address: { ...newAddress },
	// 				geoLocation: {
	// 					latitude: response.data.coordinates.latitude || "",
	// 					longitude: response.data.coordinates.longitude || "",
	// 				},
	// 			};
	// 			setOrder(updatedOrder);
	// 			setServiceableArea({
	// 				flag: true,
	// 				message: `The area with pincode is serviceable for Redcliffe Labs.`,
	// 			});
	// 		} catch (error) {
	// 			const updatedOrder = {
	// 				...order,
	// 				address: { ...newAddress },
	// 			};
	// 			setOrder(updatedOrder);
	// 			setServiceableArea({
	// 				flag: false,
	// 				message: `The area with pincode is not serviceable for Redcliffe Labs.`,
	// 			});
	// 			setIsCollectionMethodPopup(true);
	// 			setIsAddAddressPopup(false);
	// 		}
	// 	} else {
	// 		const updatedOrder = {
	// 			...order,
	// 			address: { ...newAddress },
	// 		};
	// 		setOrder(updatedOrder);
	// 		handleServiceableArea(updatedOrder);
	// 	}

	// 	setIsCollectionMethodPopup(true);
	// 	setIsAddAddressPopup(false);
	// };


	const updateAddress = (newAddress) => {
		const updatedOrder = {
			...order,
			address: { ...newAddress },
		};

		//  Keep geoLocation only if already set by user
		if (order.geoLocation?.latitude && order.geoLocation?.longitude) {
			updatedOrder.geoLocation = {
				latitude: order.geoLocation.latitude,
				longitude: order.geoLocation.longitude,
			};
		}

		setOrder(updatedOrder);

		// Run your existing serviceability check (if needed)
		handleServiceableArea(updatedOrder);

		setIsCollectionMethodPopup(true);
		setIsAddAddressPopup(false);
	};



	// Remove address from order
	// const removeAddress = () => {
	// 	const updatedOrder = {
	// 		...order,
	// 		address: {},
	// 		collectionDate: { date: {}, time: "" }, // Clear collection date and time
	// 		visitDate: { date: {}, time: "" }, // Clear visit date and time
	// 		visitCenter: "", // Clear visit center
	// 		collectionType: "", // Reset collection type (add to your order state if you store it here)
	// 	};

	// 	setOrder(updatedOrder);
	// };

	const removeAddress = () => {
		setOrder((prevOrder) => ({
			...prevOrder,
			// Wipe the address completely
			address: {},
			// Wipe home collection details
			collectionDate: {
				date: {},
				time: "",
				slotId: undefined, // Or null, if you use that, to clear Redcliffe slot id
			},
			// Wipe visit center details
			visitDate: {
				date: {},
				time: "",
			},
			visitCenter: "",
			centerCode: "", // if you have it
			collectionType: "", // if you use this in your order state
			geoLocation: { latitude: "", longitude: "" }, // optional, if geolocation is used
		}));

		// Additionally, clear related app state if needed:
		setServiceableArea({ flag: null, message: "" }); // if you use this
		setCentreAvailable({ flag: null, message: "" }); // if you use this
		setAllCentres([]); // if you fetch centers for location

		// Close popups/modals as needed:
		setIsAddAddressPopup(false);
		setIsCollectionMethodPopup(false);
	};

	// Save user's current location - longitude and latitude
	// const saveCurrentLocation = () => {
	// 	return new Promise((resolve, reject) => {
	// 		if (!navigator.geolocation) {
	// 			const error = "Geolocation is not supported by your browser.";
	// 			console.error(error);
	// 			return reject(new Error(error));
	// 		}

	// 		navigator.geolocation.getCurrentPosition(
	// 			(position) => {
	// 				const { latitude, longitude } = position.coords;

	// 				const updatedOrder = {
	// 					...order,
	// 					geoLocation: { latitude, longitude },
	// 				};

	// 				setOrder(updatedOrder);
	// 				setUserLocation({ latitude, longitude });

	// 				// Resolve with location object
	// 				resolve({ latitude, longitude });
	// 			},
	// 			(err) => {
	// 				console.error("Error getting location:", err.message);
	// 				reject(err);
	// 			},
	// 			{
	// 				enableHighAccuracy: true,
	// 				timeout: 10000,
	// 				maximumAge: 0,
	// 			}
	// 		);
	// 	});
	// };
	// ---------------original code end------------------

	const saveCurrentLocation = () => {
		return new Promise((resolve, reject) => {
			if (!navigator.geolocation) {
				alert("Geolocation is not supported by your browser.");
				return reject(new Error("Geolocation not supported"));
			}

			navigator.geolocation.getCurrentPosition(
				(position) => {
					const { latitude, longitude } = position.coords;
					setOrder((prev) => ({ ...prev, geoLocation: { latitude, longitude } }));
					setUserLocation({ latitude, longitude });
					resolve({ latitude, longitude });
				},
				(err) => {
					if (err.code === 1) {
						// Permission denied
						alert(
							" Location permission denied.\n\n" +
							" Please enable location access manually:\n" +
							"- Click the lock icon 🔒 in the address bar\n" +
							"- Set Location to Allow\n" +
							"- Reload the page"
						);

					} else {
						alert("Error getting location: " + err.message);
						reject(err);
					}
				},
				{ enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
			);
		});

	};

	// Check if pincode is serviceable of not
	// const handleServiceableArea = useCallback(
	// 	async (updatedOrder = order) => {
	// 		const brandName =
	// 			updatedOrder?.orderData[0]?.items[0]?.product?.brandName;
	// 		const pincode = updatedOrder?.address?.pincode;

	// 		// Ensure brandName and pincode are available
	// 		if (!brandName || !pincode) {
	// 			console.error("Brand name or pincode is missing.");
	// 			return;
	// 		}

	// 		if (brandName === "Redcliffe Labs") {
	// 		} else {
	// 			try {
	// 				const url = `${baseUrl}/api/orders/serviceable-area`;

	// 				// Send POST request to check if the area is serviceable
	// 				let response;

	// 				if (brandName === "Dr Lal PathLabs") {
	// 					response = await axios.post(url, {
	// 						brandName,
	// 						pincode,
	// 						city: updatedOrder?.address?.city,
	// 						state: updatedOrder?.address?.state,
	// 					});
	// 				} else {
	// 					const response = await axios.post(url, { brandName, pincode });
	// 				}

	// 				setServiceableArea({
	// 					flag: response?.data?.success,
	// 					message: response?.data?.message,
	// 				});
	// 			} catch (error) {
	// 				console.error("Error while getting serviceable area:", error);
	// 			}
	// 		}
	// 	},
	// 	[baseUrl, order]
	// );
	// ------------some update----------------------
	const handleServiceableArea = useCallback(
		async (updatedOrder = order) => {
			const brandName =
				updatedOrder?.orderData[0]?.items[0]?.product?.brandName;
			const pincode = updatedOrder?.address?.pincode;

			if (!brandName || !pincode) {
				console.error("Brand name or pincode is missing.");
				return;
			}

			if (brandName === "Redcliffe Labs") {
				// skip or handle differently
				return;
			}

			try {
				const url = `${baseUrl}/api/orders/serviceable-area`;
				let response;

				if (brandName === "Dr Lal PathLabs") {
					response = await axios.post(url, {
						brandName,
						pincode,
						city: updatedOrder?.address?.city,
						state: updatedOrder?.address?.state,
					});
				} else {
					//don't redeclare with const
					response = await axios.post(url, { brandName, pincode });
				}

				// //  use .data.flag not .data.success
				setServiceableArea({
					flag: response?.data?.flag ?? true,
					message: response?.data?.message ?? "",
				});

				// setServiceableArea({
				// 	flag: response?.data?.success ?? false,  // use success from backend
				// 	message: response?.data?.message ?? "",
				// });

			} catch (error) {
				console.error("Error while getting serviceable area:", error);
				setServiceableArea({ flag: false, message: "Unable to check area." });
			}
		},
		[baseUrl, order]
	);

	// -----------------old once
	// // Save center in visitCenter
	// const saveVisitCenter = (getCenter) => {
	// 	setOrder((prevOrder) => ({
	// 		...prevOrder,
	// 		visitCenter: getCenter?.address,
	// 		centerCode: getCenter?.code,
	// 	}));
	// };

	// // Save date in collectionDate
	// const saveCollectionDate = (dateObject) => {
	// 	const updatedOrder = {
	// 		...order,
	// 		collectionDate: {
	// 			...order.collectionDate,
	// 			date: dateObject,
	// 		},
	// 	};

	// 	setOrder(updatedOrder);
	// };

	// // Save time in collectionDate
	// const saveCollectionTime = (timeString, id = 0) => {
	// 	// Validate that the input is a string
	// 	if (typeof timeString !== "string") {
	// 		console.error("Time must be a string.");
	// 		return;
	// 	}

	// 	if (order.orderData[0].items[0].product.brandName === "Redcliffe Labs") {
	// 		const updatedOrder = {
	// 			...order,
	// 			collectionDate: {
	// 				...order.collectionDate,
	// 				time: timeString,
	// 				slotId: id,
	// 			},
	// 		};
	// 		setOrder(updatedOrder);
	// 	} else {
	// 		const updatedOrder = {
	// 			...order,
	// 			collectionDate: {
	// 				...order.collectionDate,
	// 				time: timeString,
	// 			},
	// 		};

	// 		setOrder(updatedOrder);
	// 	}
	// };

	// // Save date in collectionDate
	// const saveVisitDate = (dateObject) => {
	// 	const updatedOrder = {
	// 		...order,
	// 		visitDate: {
	// 			...order.visitDate,
	// 			date: dateObject,
	// 		},
	// 	};

	// 	setOrder(updatedOrder);
	// };

	// // Save time in collectionDate
	// const saveVisitTime = (timeString) => {
	// 	// Validate that the input is a string
	// 	if (typeof timeString !== "string") {
	// 		console.error("Time must be a string.");
	// 		return;
	// 	}

	// 	const updatedOrder = {
	// 		...order,
	// 		visitDate: {
	// 			...order.visitDate,
	// 			time: timeString,
	// 		},
	// 	};

	// 	setOrder(updatedOrder);
	// };

	// -----------------------ending old once-------------------


	// Checking if any productType is Radiology
	const hasRadiology = order?.orderData?.some((orderItem) =>
		orderItem.items.some((item) => item.product?.productType === "Radiology")
	);

	//Check if any productType other thatn Radiology
	const hasOtherThanRadiology = order?.orderData?.some((orderItem) =>
		orderItem.items.some((item) => item.product?.productType !== "Radiology")
	);

	const isChangeMethodVisible = hasRadiology && hasOtherThanRadiology;

	// Save center in visitCenter (unchanged)
	const saveVisitCenter = (getCenter) => {
		setOrder((prev) => ({
			...prev,
			visitCenter: getCenter?.address,
			centerCode: getCenter?.code,
		}));
	};

	// Save date in collectionDate (Home Collection)
	const saveCollectionDate = (dateObject) => {
		setOrder((prev) => {
			const next = {
				...prev,
				collectionDate: {
					...prev.collectionDate,
					date: dateObject,
				},
			};
			// Reset Visit only if "Change method" is NOT visible
			if (!isChangeMethodVisible) {
				next.visitDate = { date: {}, time: "" };
			}
			return next;
		});
	};

	// Save time in collectionDate (Home Collection)
	const saveCollectionTime = (timeString, id = 0) => {
		if (typeof timeString !== "string") {
			console.error("Time must be a string.");
			return;
		}

		setOrder((prev) => {
			const isRedcliffe =
				prev.orderData?.[0]?.items?.[0]?.product?.brandName === "Redcliffe Labs";

			const next = {
				...prev,
				collectionDate: {
					...prev.collectionDate,
					time: timeString,
					...(isRedcliffe ? { slotId: id } : {}),
				},
			};
			// Reset Visit only if "Change method" is NOT visible
			if (!isChangeMethodVisible) {
				next.visitDate = { date: {}, time: "" };
			}
			return next;
		});
	};

	// Save date in visitDate (Visit Nearest Center)
	const saveVisitDate = (dateObject) => {
		setOrder((prev) => {
			const next = {
				...prev,
				visitDate: {
					...prev.visitDate,
					date: dateObject,
				},
			};
			// Reset Home only if "Change method" is NOT visible
			if (!isChangeMethodVisible) {
				next.collectionDate = { date: {}, time: "" };
			}
			return next;
		});
	};

	// Save time in visitDate (Visit Nearest Center)
	const saveVisitTime = (timeString) => {
		if (typeof timeString !== "string") {
			console.error("Time must be a string.");
			return;
		}

		setOrder((prev) => {
			const next = {
				...prev,
				visitDate: {
					...prev.visitDate,
					time: timeString,
				},
			};
			// Reset Home only if "Change method" is NOT visible
			if (!isChangeMethodVisible) {
				next.collectionDate = { date: {}, time: "" };
			}
			return next;
		});
	};

	// const saveVisitDate = (dateObject) => {
	// 	setOrder((prev) => ({
	// 		...prev,
	// 		visitDate: {
	// 			...prev.visitDate,
	// 			date: dateObject,
	// 			time: "" // reset time if new date picked
	// 		},
	// 		collectionDate: { date: {}, time: "" } // always reset home collection
	// 	}));
	// };

	// const saveVisitTime = (timeString) => {
	// 	if (typeof timeString !== "string") {
	// 		console.error("Time must be a string.");
	// 		return;
	// 	}

	// 	setOrder((prev) => ({
	// 		...prev,
	// 		visitDate: {
	// 			...prev.visitDate,
	// 			time: timeString,
	// 		},
	// 		collectionDate: { date: {}, time: "" } // always reset home collection
	// 	}));
	// };

	// const saveCollectionDate = (dateObject) => {
	// 	setOrder((prev) => ({
	// 		...prev,
	// 		collectionDate: {
	// 			...prev.collectionDate,
	// 			date: dateObject,
	// 			time: "" // reset time if new date picked
	// 		},
	// 		visitDate: { date: {}, time: "" } // always reset visit
	// 	}));
	// };

	// const saveCollectionTime = (timeString, id = 0) => {
	// 	if (typeof timeString !== "string") {
	// 		console.error("Time must be a string.");
	// 		return;
	// 	}

	// 	setOrder((prev) => {
	// 		const isRedcliffe =
	// 			prev.orderData?.[0]?.items?.[0]?.product?.brandName === "Redcliffe Labs";

	// 		return {
	// 			...prev,
	// 			collectionDate: {
	// 				...prev.collectionDate,
	// 				time: timeString,
	// 				...(isRedcliffe ? { slotId: id } : {}),
	// 			},
	// 			visitDate: { date: {}, time: "" } // always reset visit
	// 		};
	// 	});
	// };


	// Calculate all prices according to products added
	const calculateTotalPrice = useCallback(
		async (orderDataToCalculate, promoCode) => {
			try {
				// Get the token and userId from cookies
				const token = Cookies.get("token");
				//const userId = Cookies.get("userId");

				// Check if token exists
				if (!token) {
					throw new Error("User is not authenticated");
				}

				// Set the Authorization header with the token
				const config = {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				};

				// Send POST request to calculate the total price
				const response = await axios.post(
					`${baseUrl}/api/cart/calculate-total-price`,
					{ orderDataToCalculate, promoCode },
					config
				);

				// Handle the response (display or use totalPrice)
				if (response?.data?.success) {
					setOrderSummary(response?.data);
					// console.log("1091 data", response?.data.extraDiscount);
				} else {
					console.error("Error:", response?.data?.message);
				}
			} catch (error) {
				console.error("Error calculating total price:", error?.message);
			}
		},
		[baseUrl]
	);

	useEffect(() => {
		if (order?.orderData?.length > 0) {
			calculateTotalPrice(order?.orderData, order?.appliedPromoCode);
		}
	}, [order?.orderData]);

	// // Apply promo code on order
	// const handleApplyPromoCode = useCallback(async () => {
	// 	try {
	// 		const token = Cookies.get("token");
	// 		const orderDataToApplyPromoCode = {
	// 			orders: order?.orderData,
	// 			collectionCharges: order?.paymentDetails.collectionCharges,
	// 		};

	// 		if (!promoCode || !order) {
	// 			setPromoCodeMessage({
	// 				flag: false,
	// 				message: "Please provide a promo code and order details.",
	// 			});
	// 			return;
	// 		}

	// 		const config = {
	// 			headers: {
	// 				Authorization: `Bearer ${token}`,
	// 			},
	// 		};

	// 		const response = await axios.post(
	// 			`${baseUrl}/api/cart/apply-promocode`,
	// 			{ promoCode, orderDataToApplyPromoCode },
	// 			config
	// 		);

	// 		if (response.data.success) {
	// 			setOrder((prevOrder) => ({
	// 				...prevOrder,
	// 				orderData: response.data.updatedOrderData,
	// 				appliedPromoCode: promoCode,
	// 				paymentDetails: {
	// 					...prevOrder.paymentDetails,
	// 					discount: response.data.totalDiscount,
	// 					collectionCharges: response.data.collectionCharges,
	// 				},
	// 			}));

	// 			if (promoCode === "FREEHOME") {
	// 				setPromoCodeMessage({
	// 					flag: true,
	// 					message: `Promo code applied successfully. You saved ₹100 on your home collection fee`,
	// 				});
	// 			} else {
	// 				setPromoCodeMessage({
	// 					flag: true,
	// 					message: `Promo code applied successfully. You saved ₹${response.data.totalDiscount}!`,
	// 				});
	// 			}
	// 			setIsPromoCode(false);
	// 		} else {
	// 			setPromoCodeMessage({
	// 				flag: false,
	// 				message: response?.data?.message || "Failed to apply promo code.",
	// 			});
	// 			if (order?.appliedPromoCode?.length > 0) {
	// 				removePromoCode();
	// 				setPromoCodeMessage({
	// 					flag: null,
	// 					message: "",
	// 				});
	// 			}
	// 		}
	// 	} catch (error) {
	// 		console.error("Error applying promo code:", error);

	// 		setPromoCodeMessage({
	// 			flag: false,
	// 			message:
	// 				error?.response?.data?.message ||
	// 				"An error occurred while applying the promo code. Please try again.",
	// 		});
	// 		if (order?.appliedPromoCode?.length > 0) {
	// 			removePromoCode();
	// 			setPromoCodeMessage({
	// 				flag: null,
	// 				message: "",
	// 			});
	// 		}
	// 	}
	// }, [baseUrl, promoCode, order?.orderData]);



	// -------------working code----------------
	// ✅ Apply promo code on order
	// const handleApplyPromoCode = useCallback(async () => {
	// 	try {
	// 		const token = Cookies.get("token");
	// 		// const orderDataToApplyPromoCode = {
	// 		// 	orders: order?.orderData,
	// 		// 	collectionCharges: order?.paymentDetails.collectionCharges,
	// 		// };

	// 		// Basic validation
	// 		if (!promoCode || !order) {
	// 			setPromoCodeMessage({
	// 				flag: false,
	// 				message: "Please provide a promo code and order details.",
	// 			});
	// 			return;
	// 		}

	// 		const orderDataToApplyPromoCode = {
	// 			orders: order?.orderData,
	// 			collectionCharges: order?.paymentDetails?.collectionCharges,
	// 		};

	// 		const config = {
	// 			headers: {
	// 				Authorization: `Bearer ${token}`,
	// 			},
	// 		};

	// 		// 🔸 API call
	// 		const response = await axios.post(
	// 			`${baseUrl}/api/cart/apply-promocode`,
	// 			{ promoCode, orderDataToApplyPromoCode },
	// 			config
	// 		);

	// 		if (response?.data?.success) {
	// 			const {
	// 				updatedOrderData,
	// 				totalDiscount,
	// 				collectionCharges,
	// 				matchedFreeTest,
	// 				freeTestsTotalMRP,
	// 				totalCartValue,
	// 				extraDiscount, // 🟡 Add this field from backend
	// 			} = response.data;

	// 			// ✅ Update order state with discount and extra discount
	// 			setOrder((prevOrder) => ({
	// 				...prevOrder,
	// 				orderData: updatedOrderData,
	// 				appliedPromoCode: promoCode,
	// 				paymentDetails: {
	// 					...prevOrder.paymentDetails,
	// 					discount: totalDiscount,
	// 					totalCartValue: totalCartValue,
	// 					matchedFreeTest: matchedFreeTest,
	// 					// extraDiscount: extraDiscount || 0, // 🟡 Add to state
	// 					freeTestsTotalMRP: freeTestsTotalMRP || 0,
	// 					collectionCharges: collectionCharges,
	// 				},
	// 			}));

	// 			// 🟢 Show success message
	// 			if (promoCode === "FREEHOME") {
	// 				setPromoCodeMessage({
	// 					flag: true,
	// 					message: `Promo code applied successfully. You saved ₹100 on your home collection fee`,
	// 				});
	// 			} else if (extraDiscount > 0) {
	// 				setPromoCodeMessage({
	// 					flag: true,
	// 					message: `Promo code applied successfully. You saved ₹${totalDiscount} + Extra ₹${extraDiscount}!`,
	// 				});
	// 			}
	// 			// if (promoCode === "FREETEST") {
	// 			// 	setPromoCodeMessage({
	// 			// 		flag: true,
	// 			// 		message: `Promo code applied successfully. You saved ₹${freeTestsTotalMRP}!`,
	// 			// 		matchedFreeTest: matchedFreeTest,

	// 			// 	});
	// 			// }

	// 			if (promoCode === "FREETEST") {
	// 				setPromoCodeMessage({
	// 					flag: true,
	// 					message: `Free Test applied: ${matchedFreeTest?.name} (Saved ₹${matchedFreeTest?.price})`,
	// 					matchedFreeTest,
	// 				});
	// 			}

	// 			else {
	// 				setPromoCodeMessage({
	// 					flag: true,
	// 					message: `Promo code applied successfully. You saved ₹${totalDiscount}!`,
	// 				});
	// 			}

	// 			setIsPromoCode(false);
	// 		} else {
	// 			// ❌ Failed case
	// 			setPromoCodeMessage({
	// 				flag: false,
	// 				message: response?.data?.message || "Failed to apply promo code.",
	// 			});
	// 			if (order?.appliedPromoCode?.length > 0) {
	// 				removePromoCode();
	// 				setPromoCodeMessage({
	// 					flag: null,
	// 					message: "",
	// 				});
	// 			}
	// 		}
	// 	} catch (error) {
	// 		console.error("Error applying promo code:", error);

	// 		setPromoCodeMessage({
	// 			flag: false,
	// 			message:
	// 				error?.response?.data?.message ||
	// 				"An error occurred while applying the promo code. Please try again.",
	// 		});

	// 		if (order?.appliedPromoCode?.length > 0) {
	// 			removePromoCode();
	// 			setPromoCodeMessage({
	// 				flag: null,
	// 				message: "",
	// 			});
	// 		}
	// 	}
	// }, [baseUrl, promoCode, order?.orderData]);
	// ------------------------

	// const handleApplyPromoCode = useCallback(async () => {
	//   try {
	//     const token = Cookies.get("token");

	//     if (!promoCode || !order) {
	//       setPromoCodeMessage({
	//         flag: false,
	//         message: "Please provide a promo code and order details.",
	//       });
	//       return;
	//     }

	//     const orderDataToApplyPromoCode = {
	//       orders: order?.orderData,
	//       collectionCharges: order?.paymentDetails?.collectionCharges,
	//     };

	//     const config = {
	//       headers: {
	//         Authorization: `Bearer ${token}`,
	//       },
	//     };

	//     const response = await axios.post(
	//       `${baseUrl}/api/cart/apply-promocode`,
	//       { promoCode, orderDataToApplyPromoCode },
	//       config
	//     );
	// 	console.log("API called apply promoCode");
	// 	console.log("Matched Free Test from API:", response.data.matchedFreeTest);

	//     if (response?.data?.success) {
	//       const {
	//         updatedOrderData,
	//         totalDiscount,
	//         collectionCharges,
	//         finalAmount,
	// 		matchedFreeTest,
	//         freeTest,
	//       } = response.data;


	//       setOrder((prevOrder) => ({
	//         ...prevOrder,
	//         orderData: updatedOrderData,
	//         appliedPromoCode: promoCode,
	// 		matchedFreeTest:matchedFreeTest,
	//         paymentDetails: {
	//           ...prevOrder.paymentDetails,
	//           discount: totalDiscount,
	// 		  matchedFreeTest:matchedFreeTest,
	//           freeTest:freeTest,
	//           finalAmount,
	//           collectionCharges: collectionCharges ?? prevOrder.paymentDetails.collectionCharges,
	//         },
	//       }));

	//       // success message
	//       if (promoCode === "FREETEST") {
	//         setPromoCodeMessage({
	//           flag: true,
	//           message: `Free Test Applied: ${freeTest?.name} (Saved ₹${freeTest?.price})`,
	//           freeTest,
	// 		  matchedFreeTest,
	//         });
	//       } else {
	//         setPromoCodeMessage({
	//           flag: true,
	//           message: `Promo code applied successfully. You saved ₹${totalDiscount}!`,
	//         });
	//       }

	//       setIsPromoCode(false);
	//     } else {
	//       setPromoCodeMessage({
	//         flag: false,
	//         message: response?.data?.message,
	//       });
	//       removePromoCode();
	//     }

	//   } catch (error) {
	//     console.error("Error applying promo code:", error);
	//     setPromoCodeMessage({
	//       flag: false,
	//       message: error?.response?.data?.message || "Error applying promo code.",
	//     });
	//     removePromoCode();
	//   }
	// }, [baseUrl, promoCode, order?.orderData]);


	const handleApplyPromoCode = useCallback(async () => {
		try {
			const token = Cookies.get("token");

			if (!promoCode || !order) {
				setPromoCodeMessage({
					flag: false,
					message: "Please provide a promo code and order details.",
				});
				return;
			}

			const orderDataToApplyPromoCode = {
				orders: order?.orderData,
				collectionCharges: order?.paymentDetails?.collectionCharges,
			};

			const config = {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			};

			const response = await axios.post(
				`${baseUrl}/api/cart/apply-promocode`,
				{ promoCode, orderDataToApplyPromoCode },
				config
			);

			// console.log("Matched Free Test from API:", response.data.matchedFreeTest);

			if (response?.data?.success) {
				const {
					updatedOrderData,
					totalDiscount,
					collectionCharges,
					finalAmount,
					matchedFreeTest,
					freeTest,
				} = response.data;

				// IMPORTANT: Build the NEW order object FIRST
				const newOrder = {
					...order,
					orderData: updatedOrderData,
					appliedPromoCode: promoCode,

					// root-level for easy access
					matchedFreeTest: matchedFreeTest || {},

					paymentDetails: {
						...order.paymentDetails,
						discount: totalDiscount,
						matchedFreeTest: matchedFreeTest || {},
						freeTest: freeTest || {},
						finalAmount,
						collectionCharges:
							collectionCharges ?? order.paymentDetails.collectionCharges,
					},
				};

				// Now update React state
				setOrder(newOrder);

				// SUCCESS MESSAGE
				if (promoCode === "FREETEST") {
					setPromoCodeMessage({
						flag: true,
						message: `Free Test Applied: ${freeTest?.name} (Saved ₹${freeTest?.price})`,
						freeTest,
						matchedFreeTest,
					});
				} else {
					setPromoCodeMessage({
						flag: true,
						message: `Promo code applied successfully. You saved ₹${totalDiscount}!`,
					});
				}

				setIsPromoCode(false);
			} else {
				setPromoCodeMessage({
					flag: false,
					message: response?.data?.message,
				});
				removePromoCode();
			}
		} catch (error) {
			console.error("Error applying promo code:", error);
			setPromoCodeMessage({
				flag: false,
				message: error?.response?.data?.message || "Error applying promo code.",
			});
			removePromoCode();
		}
	}, [baseUrl, promoCode, order]);




	const removePromoCode = () => {
		setPromoCode("");
		setOrder((prevOrder) => ({
			...prevOrder,
			appliedPromoCode: "",
			orderData: prevOrder.orderData.map((order) => ({
				...order,
				items: order.items.map((item) => ({
					...item,
					discountPrice: "",
					discountPercentage: "",
				})),
			})),
			paymentDetails: {
				...prevOrder.paymentDetails,
				discount: "",
				totalDiscountPrice: "",
				collectionCharges: 100.0,
			},
		}));
	};

	// Populate `userDetails` dynamically
	useEffect(() => {
		if (userProfile) {
			setOrder((prevOrder) => ({
				...prevOrder,
				userDetails: {
					name: userProfile?.name || "",
					contact: userProfile?.contact || "",
					email: userProfile?.email || "",
				},
			}));
		}
	}, [userProfile]);

	// Populate `paymentDetails` dynamically
	useEffect(() => {
		// Only update if `orderSummary` has valid data
		if (orderSummary?.success) {
			setOrder((prevOrder) => ({
				...prevOrder,
				freeTest: {
					name: order.name,
					brand: orderSummary.brand,
					price: orderSummary.price,
				},
				// matchedFreeTest:{
				// 	name:"",
				// 	brand:"",
				// 	price:"",
				// },
				paymentDetails: {
					currency: orderSummary.currency,
					totalPrice: orderSummary.totalPrice,
					totalDiscountPrice: orderSummary.totalDiscountPrice,
					extraDiscount: orderSummary.extraDiscount,
					matchedFreeTest: orderSummary.matchedFreeTest,
					freeTest: orderSummary.freeTest,
					totalCartValue: orderSummary.totalCartValue,
					freeTestsTotalMRP: orderSummary.freeTestsTotalMRP,
					finalAmount: orderSummary.finalAmount,
					collectionCharges: orderSummary.collectionCharges,
					freeChargeDifference: orderSummary.freeChargeDifference,
					discount: orderSummary.discount,
					platformFee: orderSummary.platformFee,
				},
			}));
		}
	}, [orderSummary]);

	// Remove object from orderData it items array is empty
	useEffect(() => {
		const cleanOrderData = () => {
			setOrder((prevOrder) => {
				const cleanedOrderData = prevOrder.orderData.filter(
					(data) => data.items && data.items.length > 0
				);

				// Update the state only if the data was cleaned
				if (cleanedOrderData.length !== prevOrder.orderData.length) {
					return { ...prevOrder, orderData: cleanedOrderData };
				}
				return prevOrder;
			});
		};

		if (order?.orderData?.length > 0) {
			cleanOrderData();
		}
	}, [order?.orderData]);

	const getRedcliffeLabsTimeSlots = async (collectionDate) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/labs/get-redcliffe-time-slots`,
				{
					collectionDate,
					latitude: order.geoLocation.latitude,
					longitude: order.geoLocation.longitude,
				}
			);

			return response.data.results; // Should be the `items` array returned by the backend
		} catch (error) {
			console.error(
				"Error calling backend to get Redcliffe Labs time slots:",
				error
			);
			throw error;
		}
	};


	const createRedcliffeLabsTemporaryOrder = async (order) => {
		try {
			const response = await axios.post(
				// `${baseUrl}/api/labs/create-redcliffe-temporary-order`,
				`${baseUrl}/api/labs/create-order`,
				{
					order,
				}
			);
			console.log(response.data, "Redcliffe Labs temporary order response");
			return response.data;
		} catch (error) {
			console.error("Error creating Redcliffe Labs temporary order:", error);
			throw error;
		}
	};

	const createRedcliffeLabsPermanentOrder = async (bookingId) => {
		// try {
		// 	const response = await axios.post(
		// 		`${baseUrl}/api/labs/create-redcliffe-permanent-order`,
		// 		{
		// 			bookingId,
		// 		}
		// 	);
		// 	console.log(response.data, "Redcliffe Labs permanent order response");
		// 	return response.data;
		// } catch (error) {
		// 	console.error("Error creating Redcliffe Labs permanent order:", error);
		// 	throw error;
		// }
	};

	// Create an order-(handleCreateOrder)-----------old once-----------------
	// const handleCreateOrder = useCallback(async () => {
	// 	try {
	// 		console.log("OrderProcessing context, line 1294 handleCreateOrder");
	// 		const url = `${baseUrl}/api/create-order`;
	// 		const data = {
	// 			amount: Math.round(parseFloat(orderSummary?.finalAmount) * 100),
	// 			currency,
	// 			receipt,
	// 		};

	// 		const response = await axios.post(url, data, {
	// 			headers: {
	// 				"Content-Type": "application/json",
	// 			},
	// 		});

	// 		if (response?.data?.success) {
	// 			const createOrderDataResponse = response?.data?.createOrderData;

	// 			// Open Razorpay payment window
	// 			const options = {
	// 				key: "rzp_test_bndj2YHgGFUarQ",
	// 				// key: "rzp_live_mlO20lt64Wtvpj",
	// 				amount: createOrderDataResponse?.amount,
	// 				currency: createOrderDataResponse?.currency,
	// 				name: "Fine Labs",
	// 				description: "Order Payment",
	// 				image: "/assets/finelabs-logo-rp.png",
	// 				order_id: createOrderDataResponse?.id, // Razorpay order ID
	// 				handler: function (paymentResponse) {
	// 					// Handle successful payment
	// 					setOrder((prevOrder) => ({
	// 						...prevOrder,
	// 						orderId: createOrderDataResponse?.id,
	// 					}));
	// 					setIsPaymentDone(true);
	// 				},
	// 				prefill: {
	// 					name: userProfile?.name || "",
	// 					email: userProfile?.email || "",
	// 					contact: userProfile?.contact || "",
	// 				},
	// 				notes: {
	// 					address: "",
	// 				},
	// 				theme: {
	// 					color: "#F37254",
	// 				},
	// 			};

	// 			const razorpay = new window.Razorpay(options);

	// 			razorpay.on("payment.failed", function (response) {
	// 				console.error("Payment failed:", response.error);
	// 				// Handle payment failure
	// 			});

	// 			razorpay.open();
	// 		} else {
	// 			console.log("Order creation failed:", response?.data);
	// 		}
	// 	} catch (err) {
	// 		console.error(
	// 			"Failed to create order:",
	// 			err.response?.data || "Something went wrong"
	// 		);
	// 	}
	// }, [baseUrl, currency, receipt, orderSummary?.finalAmount]);




	// --------------new handleCreateOrder--------------


	const handleCreateOrder = useCallback(async () => {
		try {
			// console.log("OrderProcessing context → handleCreateOrder");

			const url = `${baseUrl}/api/create-order`;

			//  Check if order contains non-radiology products
			const hasNonRadiology = order?.orderData?.some((orderItem) =>
				orderItem.items.some((item) => item.product?.productType !== "Radiology")
			);



			//  Helper function to hit API
			const createOrderRequest = async (geoLocation = null) => {
				const data = {
					amount: Math.round(parseFloat(orderSummary?.finalAmount) * 100),
					currency,
					receipt,
					...(geoLocation && { geoLocation }), // include location only if present
				};

				// console.log(" Sending payload to BE:", data);

				const response = await axios.post(url, data, {
					headers: { "Content-Type": "application/json" },
				});

				if (response?.data?.success) {
					const createOrderDataResponse = response?.data?.createOrderData;

					//  Razorpay options
					const options = {
						// key: "rzp_test_bndj2YHgGFUarQ",
						key: "rzp_live_mlO20lt64Wtvpj",
						amount: createOrderDataResponse?.amount,
						currency: createOrderDataResponse?.currency,
						name: "Fine Labs",
						description: "Order Payment",
						image: "/assets/finelabs-logo-rp.png",
						order_id: createOrderDataResponse?.id,
						handler: function (paymentResponse) {
							setOrder((prevOrder) => ({
								...prevOrder,
								orderId: createOrderDataResponse?.id,
							}));
							setIsPaymentDone(true);
						},
						prefill: {
							name: userProfile?.name || "",
							email: userProfile?.email || "",
							contact: userProfile?.contact || "",
						},
						notes: { address: "" },
						theme: { color: "#F37254" },
					};

					const razorpay = new window.Razorpay(options);

					razorpay.on("payment.failed", function (response) {
						console.error(" Payment failed:", response.error);
					});

					razorpay.open();
				} else {
					console.error(" Order creation failed:", response?.data);
				}
			};
			//  If order contains non-radiology → get user location
			if (hasNonRadiology && navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					async (position) => {
						const geoLocation = {
							latitude: position.coords.latitude,
							longitude: position.coords.longitude,
						};
						// console.log(" User Location (FE):", geoLocation);
						await createOrderRequest(geoLocation);
					},
					async (error) => {
						console.warn(" Location access denied:", error);
						await createOrderRequest(); // fallback without location
					}
				);
			} else {
				//  Radiology-only order → skip location
				await createOrderRequest();
			}

		} catch (err) {
			console.error(" Failed to create order:", err.response?.data || err.message);
		}
	}, [baseUrl, currency, receipt, orderSummary?.finalAmount, order, userProfile]);



	// ---------------previous one--------------------
	// Save created order
	// const createOrder = useCallback(async () => {
	// 	const url = `${baseUrl}/api/orders/create-order`;

	// 	const token = Cookies.get("token");
	// 	const userId = Cookies.get("userId");

	// 	// Check for missing authentication details
	// 	if (!token || !userId) {
	// 		console.error("Missing authentication details.");
	// 		return { success: false, message: "Authentication required." };
	// 	}

	// 	try {
	// 		const headers = {
	// 			Authorization: `Bearer ${token}`,
	// 			"Content-Type": "application/json",
	// 		};

	// 		let response;
	// 		// Send POST request to create order
	// 		if (order.orderData[0].items[0].product.brandName === "Redcliffe Labs") {
	// 			const tempOrder = await createRedcliffeLabsTemporaryOrder(order);
	// 			await createRedcliffeLabsPermanentOrder(tempOrder.booking_id);
	// 			response = await axios.post(
	// 				url,
	// 				{ ...order, userId, bookingId: tempOrder.booking_id },
	// 				{ headers }
	// 			);
	// 		} else {
	// 			response = await axios.post(url, { ...order, userId }, { headers });
	// 		}

	// 		if (response?.status == 201) {
	// 			setIsPaymentDone(false);
	// 			fetchOrders();
	// 			navigate("/payment/thank-you");
	// 			return response.data;
	// 		} else {
	// 			console.error("Failed to create order:", response.data.message);
	// 			return response.data;
	// 		}
	// 	} catch (error) {
	// 		console.error("Error creating order:", error.message);

	// 		return { success: false, message: error.message };
	// 	}
	// }, [order]);

	// ------------------------when order is create and payment is done so reset the state---------------------
	// const createOrder = useCallback(async () => {
	// 	console.log("createORder line 1412 in order processing context");
	// 	const url = `${baseUrl}/api/orders/create-order`;
	// 	const token = Cookies.get("token");
	// 	const userId = Cookies.get("userId");

	// 	if (!token || !userId) {
	// 		console.error("Missing authentication details.");
	// 		return { success: false, message: "Authentication required." };
	// 	}

	// 	try {
	// 		const headers = {
	// 			Authorization: `Bearer ${token}`,
	// 			"Content-Type": "application/json",
	// 		};

	// 		let response;
	// 		if (order.orderData[0]?.items[0]?.product?.brandName === "Redcliffe Labs") {
	// 			const tempOrder = await createRedcliffeLabsTemporaryOrder(order);
	// 			await createRedcliffeLabsPermanentOrder(tempOrder.booking_id);
	// 			response = await axios.post(
	// 				url,
	// 				{ ...order, userId, bookingId: tempOrder.booking_id },
	// 				{ headers }
	// 			);
	// 		} else {
	// 			response = await axios.post(url, { ...order, userId }, { headers });
	// 		}


	// 		if (response?.status === 201) {
	// 			setIsPaymentDone(false);
	// 			fetchOrders();

	// 			//  Reset order state & clear from localStorage
	// 			const emptyOrder = {
	// 				orderId: "",
	// 				userDetails: { name: "", contact: "", email: "" },
	// 				orderData: [],
	// 				address: {},
	// 				paymentDetails: {
	// 					currency: "₹",
	// 					totalPrice: "",
	// 					totalDiscountPrice: "",
	// 					finalAmount: "",
	// 					collectionCharges: "",
	// 					freeChargeDifference: "",
	// 					discount: "",
	// 					platformFee: "",
	// 				},
	// 				collectionMode: "",
	// 				visitCenter: "",
	// 				centerCode: "",
	// 				collectionDate: { date: {}, time: "" },
	// 				visitDate: { date: {}, time: "" },
	// 				geoLocation: { longitude: "", latitude: "" },
	// 				status: "Pending",
	// 				appliedPromoCode: "",
	// 			};

	// 			setOrder(emptyOrder);
	// 			localStorage.setItem("order", JSON.stringify(emptyOrder)); // keeps clean slate

	// 			navigate("/payment/thank-you");
	// 			return response.data;
	// 		} else {
	// 			console.error("Failed to create order:", response.data.message);
	// 			return response.data;
	// 		}
	// 	} catch (error) {
	// 		console.error("Error creating order:", error.message);
	// 		return { success: false, message: error.message };
	// 	}
	// }, [order]);



	// --------------create order with geolocation and reset order after submit order----------
	const createOrder = useCallback(async () => {
		// const createOrder = (async () => {
		console.log("createOrder line 1412 in order processing context");
		const url = `${baseUrl}/api/orders/create-order`;
		const token = Cookies.get("token");
		const userId = Cookies.get("userId");

		if (!token || !userId) {
			console.error("Missing authentication details.");
			return { success: false, message: "Authentication required." };
		}
		console.log("try triggering")
		try {
			console.log("try trigger")
			const headers = {
				Authorization: `Bearer ${token}`,
				"Content-Type": "application/json",
			};

			//  Check if any product is not Radiology
			const hasNonRadiology = order?.orderData?.some((orderItem) =>
				orderItem.items.some((item) => item.product?.productType !== "Radiology")
			);

			//  Function to send order to backend
			const sendOrderRequest = async (geoLocation = null, bookingId = null) => {
				let payload = { ...order, userId };

				if (bookingId) {
					payload.bookingId = bookingId;
				}

				// Attach geolocation if present
				if (geoLocation) {
					payload.geoLocation = geoLocation;
				}

				return axios.post(url, payload, { headers });
			};
			console.log("Order create function send order")
			let response;
			// if (order.orderData[0]?.items[0]?.product?.brandName === "Redcliffe Labs" ) {
			// 	// Special case for Redcliffe Labs
			// 	const tempOrder = await createRedcliffeLabsTemporaryOrder(order);
			// 	await createRedcliffeLabsPermanentOrder(tempOrder.booking_id);

			// 	if (hasNonRadiology && navigator.geolocation) {
			// 		// Get location
			// 		await new Promise((resolve, reject) => {
			// 			navigator.geolocation.getCurrentPosition(
			// 				async (position) => {
			// 					const geoLocation = {
			// 						latitude: position.coords.latitude,
			// 						longitude: position.coords.longitude,
			// 					};
			// 					console.log(" User Location (FE):", geoLocation);
			// 					response = await sendOrderRequest(geoLocation, tempOrder.booking_id);
			// 					resolve();
			// 				},
			// 				async (error) => {
			// 					console.error("Location access denied:", error);
			// 					response = await sendOrderRequest(null, tempOrder.booking_id);
			// 					resolve();
			// 				}
			// 			);
			// 		});
			// 	} else {
			// 		response = await sendOrderRequest(null, tempOrder.booking_id);
			// 	}
			// } else {
			// 	// Normal case (not Redcliffe Labs)
			// 	if (hasNonRadiology && navigator.geolocation) {
			// 		await new Promise((resolve, reject) => {
			// 			navigator.geolocation.getCurrentPosition(
			// 				async (position) => {
			// 					const geoLocation = {
			// 						latitude: position.coords.latitude,
			// 						longitude: position.coords.longitude,
			// 					};
			// 					console.log(" User Location (FE):", geoLocation);
			// 					response = await sendOrderRequest(geoLocation);
			// 					resolve();
			// 				},
			// 				async (error) => {
			// 					console.error("Location access denied:", error);
			// 					response = await sendOrderRequest();
			// 					resolve();
			// 				}
			// 			);
			// 		});
			// 	} else {
			// 		response = await sendOrderRequest();
			// 	}
			// }
			console.log("hitting line 1836")
			if (hasNonRadiology && navigator.geolocation) {
				await new Promise((resolve, reject) => {
					navigator.geolocation.getCurrentPosition(
						async (position) => {
							const geoLocation = {
								latitude: position.coords.latitude,
								longitude: position.coords.longitude,
							};
							console.log(" User Location (FE):", geoLocation);
							response = await sendOrderRequest(geoLocation);
							resolve();
						},
						async (error) => {
							console.error("Location access denied:", error);
							response = await sendOrderRequest();
							resolve();
						}
					);
				});
			} else {
				response = await sendOrderRequest();
			}

			console.log("order creating response")
			console.log("Order creation response:", response);
			console.log("Response status:", response?.status);
			console.log("order created successfully");

			//  Handle response
			if (response?.status === 201) {
				setIsPaymentDone(false);
				fetchOrders();

				// Reset order state & clear from localStorage
				const emptyOrder = {
					orderId: "",
					userDetails: { name: "", contact: "", email: "" },
					orderData: [],
					address: {},
					matchedFreeTest: {},
					freeTest: {},
					paymentDetails: {
						currency: "₹",
						totalPrice: "",
						totalCartValue: "",
						totalDiscountPrice: "",
						finalAmount: "",
						collectionCharges: "",
						freeChargeDifference: "",
						freeTestsTotalMRP: "",
						// matchedFreeTest: "",
						// freeTest: "",
						discount: "",
						platformFee: "",
					},
					collectionMode: "",
					visitCenter: "",
					centerCode: "",
					collectionDate: { date: {}, time: "" },
					visitDate: { date: {}, time: "" },
					geoLocation: { longitude: "", latitude: "" },
					status: "Pending",
					appliedPromoCode: "",
				};
				console.log("Empty Order, contact:", emptyOrder.userDetails.contact);
				console.log("Emtpy order", emptyOrder)
				console.log("Matched freeTest in orderprocessing", emptyOrder.freeTest);
				// console.log("empty Order", emptyOrder.matchedFreeTest)
				setOrder(emptyOrder);
				localStorage.setItem("order", JSON.stringify(emptyOrder));
				console.log("local storage", localStorage.getItem("order"));
				navigate("/payment/thank-you");
				console.log("📦 Empty order template (before any response):", emptyOrder);

				return response.data;
			} else {
				console.error("Failed to create order:", response.data.message);
				return response.data;
			}

		} catch (error) {
			console.error("Error creating order:", error.message);
			return { success: false, message: error.message };
		}
	}, [order]);


	// useEffect(() => {
	// 	console.log("Order Updated:", order);
	// 	console.log("Order matchedFreeTest:", order.matchedFreeTest);
	// 	console.log("Payment matchedFreeTest:", order.paymentDetails.matchedFreeTest);
	// }, [order]);


	useEffect(() => {
		if (isPaymentDone) {
			createOrder();
		}
	}, [isPaymentDone]);

	// Fetch all user's orders
	const fetchOrders = useCallback(async () => {
		const token = Cookies.get("token");
		const userId = Cookies.get("userId");

		if (!token || !userId) {
			console.error("Authentication required. Missing token or userId.");
			return;
		}

		try {
			const headers = {
				Authorization: `Bearer ${token}`,
			};

			const response = await axios.get(`${baseUrl}/api/orders/get-order`, {
				params: { userId },
				headers,
			});

			if (response?.data?.success) {
				setAllOrders(response?.data?.orders);
			} else {
				console.error(response?.data?.message);
				return [];
			}
		} catch (error) {
			console.error("Error fetching orders:", error.message);
		}
	}, []);

	// Fetch centres by city and brandName
	const fetchCentresByCityAndBrand = async (brand = "", city = "") => {
		try {
			const url = `${baseUrl}/api/centre/centres/${brand}/${city}`;
			const response = await axios.get(url);
			if (response?.data?.success) {
				setAllCentres(response?.data?.centres);
			}
			console.log("Response", response);
		} catch (error) {
			console.error("Error fetching centres:", error);
		}
	};

	// const fetchCentresByCityAndBrandAndType = async (
	// 	brand = "",
	// 	city = "",
	// 	type = []
	// ) => {
	// 	try {
	// 		const url = `${baseUrl}/api/centre/centres/${brand}/${city}`;
	// 		const response = await axios.get(url, {
	// 			params: { type },
	// 		});
	// 		console.log(response.data, "-----------------Centres by city and brand response");
	// 		if (response?.data?.success) {
	// 			setCentreAvailable({ flag: true, message: response?.data?.message });
	// 			setAllCentres(response?.data?.centres);
	// 		} else {
	// 			setCentreAvailable({ flag: false, message: response?.data?.message });
	// 		}
	// 	} catch (error) {
	// 		console.error("Error fetching centres:", error);
	// 	}
	// };


	const fetchCentresByCityAndBrandAndType = async (
		brand = "",
		city = "",
		type = []
	) => {
		// console.log("Brand:", brand);
		// console.log("City:", city);
		// console.log("Type:", type);
		try {
			// Ensure no leading/trailing spaces and proper encoding
			const encodedBrand = encodeURIComponent(brand.trim());
			const encodedCity = encodeURIComponent(city.trim());

			const url = `${baseUrl}/api/centre/centres/${encodedBrand}/${encodedCity}`;
			// console.log("Fetching centres from URL:", url);
			// Send type only if not empty
			const params = type.length ? { type } : {};
			// console.log("line 1112:", encodedBrand, encodedCity);
			// console.log("Params:", params);
			const response = await axios.get(url, { params });

			// console.log(response.data, "----------------- Centres by city and brand response");

			if (response?.data?.success) {
				setCentreAvailable({ flag: true, message: response?.data?.message });
				setAllCentres(response?.data?.centres);
			} else {
				setCentreAvailable({ flag: false, message: response?.data?.message });
			}
		} catch (error) {
			console.error("Error fetching centres:", error);
		}
	};

	// Update collection type
	useEffect(() => {
		const updateCollectionType = () => {
			setOrder((prevOrder) => ({
				...prevOrder,
				collectionMode: collectionType,
			}));
		};

		updateCollectionType();
	}, [collectionType]);

	const handleCancelRedcliffeOrder = async (bookingId) => {
		try {
			const response = await axios.post(
				`${baseUrl}/api/labs/cancel-redcliffe-order`,
				{
					bookingId,
				}
			);
			console.log(response.data, "Redcliffe Labs cancel booking response");
			return response.data;
		} catch (error) {
			console.error("Error cancelling Redcliffe Labs booking:", error);
			throw error;
		}
	};

	return (
		<OrderProcessingContext.Provider
			value={{
				order,
				setOrder,
				addProductToCart,
				addANewMember,
				removeProductById,
				setIndexToAddPatient,
				updatePatientAtIndex,
				isAddMemberPopup,
				setIsAddMemberPopup,
				removePatientAtIndex,
				removeSpecificProduct,
				updateAddress,
				isAddAddressPopup,
				// matchedFreeTest,
				setIsAddAddressPopup,
				removeAddress,
				saveCurrentLocation,
				countAllCartProducts,
				serviceableArea,
				saveCollectionDate,
				saveCollectionTime,
				saveVisitDate,
				saveVisitTime,
				isPromoCode,
				setIsPromoCode,
				promoCode,
				setPromoCode,
				handleApplyPromoCode,
				promoCodeMessage,
				setPromoCodeMessage,
				handleCreateOrder,
				fetchOrders,
				allOrders,
				setAllOrders,
				removePromoCode,
				setAddMoreTestIndex,
				saveVisitCenter,
				fetchCentresByCityAndBrand,
				allCentres,
				collectionType,
				setCollectionType,
				isCollectionMethodPopup,
				setIsCollectionMethodPopup,
				addProductsToCart,
				removeProductsById,
				handleServiceableArea,
				getRedcliffeLabsTimeSlots,
				createRedcliffeLabsTemporaryOrder,
				handleCancelRedcliffeOrder,
				fetchCentresByCityAndBrandAndType,
				centreAvailable,
				setAllCentres,
				setCentreAvailable,
			}}>
			{children}

			{/* {order?.matchedFreeTest?.name && (
				<div className="text-green-600 font-semibold">
					Free Test Selected: {order.matchedFreeTest.name}
				</div>
			)} */}
			
			{/* {console.log("matchedFreeTest in 2247", order?.matchedFreeTest?.name)} */}
		</OrderProcessingContext.Provider>
	);
};

export const useOrderProcessingContext = () =>
	useContext(OrderProcessingContext);

export default OrderProcessingProvider;




// import {
// 	createContext,
// 	useContext,
// 	useState,
// 	useEffect,
// 	useCallback,
// } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { baseUrl } from "../utils/OtherUtils";
// import { useAuthContext } from "./AuthContext";
// import { useProfileContext } from "./ProfileContext";
// import { useNavigate } from "react-router-dom";

// export const OrderProcessingContext = createContext();

// const OrderProcessingProvider = ({ children }) => {
// 	const {
// 		setIsAuth,
// 		isLoggedIn,
// 		handleNotification,
// 		setUserLocation,
// 		userLocation,
// 	} = useAuthContext();
// 	const { userProfile } = useProfileContext();
// 	const navigate = useNavigate();

// 	// // Save order on localStorage
// 	// const saveOrderToLocalStorage = (order) => {
// 	// 	localStorage.setItem("finelabsOrder", JSON.stringify(order));
// 	// };

// 	// Get order from localStorage
// 	// const getOrderFromLocalStorage = () => {
// 	// 	const storedOrder = localStorage.getItem("finelabsOrder");
// 	// 	return storedOrder ? JSON.parse(storedOrder) : null;
// 	// };

// 		const getOrderFromLocalStorage = () => {
// 			try {
// 				const raw = localStorage.getItem("finelabsOrder");
// 				return raw ? JSON.parse(raw) : null;
// 			} catch {
// 				return null;
// 			}
// 		};

// 	const [order, setOrder] = useState(() => {
// 		const savedOrder = getOrderFromLocalStorage();
// 		return (
// 			savedOrder || {
// 				orderId: "",
// 				userDetails: { name: "", contact: "", email: "" },
// 				orderData: [],
// 				address: {},
// 				paymentDetails: {
// 					currency: "₹",
// 					totalPrice: "",
// 					totalDiscountPrice: "",
// 					finalAmount: "",
// 					collectionCharges: "",
// 					freeChargeDifference: "",
// 					discount: "",
// 					platformFee: "",
// 				},
// 				collectionMode: "",
// 				visitCenter: "",
// 				centerCode: "",
// 				collectionDate: { date: {}, time: "" },
// 				visitDate: { date: {}, time: "" },
// 				geoLocation: { longitude: "", latitude: "" },
// 				status: "Pending",
// 				appliedPromoCode: "",
// 			}
// 		);
// 	});
// 	// Save order on localStorage
// 	const saveOrderToLocalStorage = (order) => {
// 		localStorage.setItem("finelabsOrder", JSON.stringify(order));
// 	};
// 	const [indexToAddPatient, setIndexToAddPatient] = useState(null);
// 	const [isAddMemberPopup, setIsAddMemberPopup] = useState(false);
// 	const [isAddAddressPopup, setIsAddAddressPopup] = useState(false);
// 	const [serviceableArea, setServiceableArea] = useState({
// 		flag: null,
// 		message: "",
// 	});
// 	const [centreAvailable, setCentreAvailable] = useState({
// 		flag: null,
// 		message: "",
// 	});
// 	const [isPromoCode, setIsPromoCode] = useState(false);
// 	const [promoCode, setPromoCode] = useState("");
// 	const [promoCodeMessage, setPromoCodeMessage] = useState({
// 		flag: null,
// 		message: "",
// 	});
// 	const [orderSummary, setOrderSummary] = useState({});
// 	const currency = "INR";
// 	const receipt = "receipt_#0";
// 	const [isPaymentDone, setIsPaymentDone] = useState(false);
// 	const [allOrders, setAllOrders] = useState([]);
// 	const [addMoreTestIndex, setAddMoreTestIndex] = useState();
// 	const [allCentres, setAllCentres] = useState([]);

// 	// const [collectionType, setCollectionType] = useState("Home");
// 	const [collectionType, setCollectionType] = useState("Visit");

// 	const getUserIdFromOrder = () => {
// 		try {
// 			const raw = localStorage.getItem("finelabsOrder");
// 			if (!raw) return null;
// 			const parsed = JSON.parse(raw);
// 			return parsed?.userId || null; // assuming finelabsOrder has userId
// 		} catch {
// 			return null;
// 		}
// 	};

// 	const userId = getUserIdFromOrder();  // get it once here

// 	// 	useEffect(() => {
// 	// 		if (!userId) return;
// 	// // api/collectionType/get-collectionType
// 	// 		axios
// 	// 			.get(`http://localhost:5000/api/collectionType/get-collectionType/${userId}`)
// 	// 			.then((res) => {
// 	// 				if (res.data?.collectionType) {
// 	// 					setCollectionType(res.data.collectionType);
// 	// 				}
// 	// 				console.log("Collection Type:", collectionType);
// 	// 			})
// 	// 			.catch((err) => {
// 	// 				console.error("Error fetching collection type:", err);
// 	// 			});
// 	// 	}, [userId]);

// 	// 	const handleAddCartCollectionType = async (type) => {
// 	// 		console.log("handleAddCartColl", type);
// 	// 		setCollectionType(type);
// 	// 		try {

// 	// 			await axios.post("http://localhost:5000/api/collectionType/add-collectionType", {
// 	// 				userId,
// 	// 				collectionType: type,
// 	// 			});
// 	// 		} catch (err) {
// 	// 			console.error("Error updating:", err);
// 	// 		}
// 	// 	};



// 	useEffect(() => {
// 		const savedType = localStorage.getItem("collectionType");
// 		if (savedType) {
// 			setCollectionType(savedType);
// 		}
// 	}, []);

// 	// Save to localStorage whenever it changes
// 	useEffect(() => {
// 		localStorage.setItem("collectionType", collectionType);
// 	}, [collectionType]);

// 	const [isCollectionMethodPopup, setIsCollectionMethodPopup] = useState(false);



// 	// Update localStorage whenever `order` changes
// 	useEffect(() => {
// 		saveOrderToLocalStorage(order);
// 	}, [order]);


// 	// inside context or wherever you manage notification state
// 	// const handleNotification = (type, message, position = "bottom-right") => {
// 	// 	setNotificationData({ type, message, position });
// 	// };

// 	// Add a product to the items array of all objects in orderData
// 	const addProductToCart = (product) => {
// 		if (!isLoggedIn) {
// 			setIsAuth(true);
// 			return;
// 		}

// 		// Check if any product already exists
// 		const existingBrand = order.orderData
// 			.flatMap((entry) => entry.items.map((item) => item.product.brandName))
// 			.find((brandName) => brandName); // Get the brandName of the first product if any

// 		// Validate brandName if there's already a product in the cart
// 		if (existingBrand && existingBrand !== product.brandName) {
// 			handleNotification(
// 				false,
// 				// `You can only add products from the ${existingBrand}`
// 				"Please add products of a single brand at a time, To avoid multiple sample collection."
// 			);
// 			return;
// 		}
// 		else if (product.brandName === 'Dr Lal PathLabs') {
// 			handleNotification(
// 				"info",
// 				"💡 Dr. Lal PathLabs services are paused for now. Don’t worry—you can still book tests from our other trusted partners.",
// 				"center"   //position
// 			);
// 			return;

// 		}

// 		const updatedOrder = {
// 			...order,
// 			orderData:
// 				Array.isArray(order.orderData) && order.orderData.length > 0
// 					? order.orderData.map((entry, index) => {
// 						// console.log("insideUpdatedOrder", entry);

// 						if (addMoreTestIndex !== null && addMoreTestIndex !== undefined) {
// 							// Add only to the specific index

// 							return index === addMoreTestIndex
// 								? {
// 									...entry,

// 									items: [
// 										...entry.items,

// 										{ product, discountPrice: "", discountPercentage: "" },
// 									],
// 								}
// 								: entry;
// 						}

// 						// If addMoreTestIndex is null/undefined, add to all entries

// 						return {
// 							...entry,

// 							items: [
// 								...entry.items,

// 								{ product, discountPrice: "", discountPercentage: "" },
// 							],
// 						};
// 					})
// 					: [
// 						// If orderData is empty or undefined, create a new entry

// 						{
// 							items: [{ product, discountPrice: "", discountPercentage: "" }],
// 						},
// 					], // Initialize orderData with a new entry if it's empty
// 		};

// 		setOrder(updatedOrder);
// 		setAddMoreTestIndex();
// 	};

// 	// Add multiple products to the items array of all objects in orderData
// 	const addProductsToCart = (products) => {
// 		if (!isLoggedIn) {
// 			setIsAuth(true);
// 			return;
// 		}

// 		if (!Array.isArray(products) || products.length === 0) {
// 			handleNotification(false, "No products to add");
// 			return;
// 		}

// 		// Check if any product already exists
// 		const existingBrand = order.orderData
// 			.flatMap((entry) => entry.items.map((item) => item.product.brandName))
// 			.find((brandName) => brandName); // Get the brandName of the first product if any

// 		// Get the brandName of the first product in the array to add
// 		const incomingBrand = products[0].brandName;

// 		// Validate that all products in the array have the same brandName
// 		const allSameBrand = products.every(
// 			(product) => product.brandName === incomingBrand
// 		);

// 		if (!allSameBrand) {
// 			handleNotification(
// 				false,
// 				"Please add products of a single brand at a time, to avoid multiple sample collection."
// 			);
// 			return;
// 		}

// 		// Validate brandName if there's already a product in the cart
// 		if (existingBrand && existingBrand !== incomingBrand) {
// 			handleNotification(
// 				false,
// 				"Please add products of a single brand at a time, to avoid multiple sample collection."
// 			);
// 			return;
// 		}

// 		const updatedOrder = {
// 			...order,
// 			orderData:
// 				Array.isArray(order.orderData) && order.orderData.length > 0
// 					? order.orderData.map((entry, index) => {
// 						if (addMoreTestIndex !== null && addMoreTestIndex !== undefined) {
// 							// Add only to the specific index
// 							return index === addMoreTestIndex
// 								? {
// 									...entry,
// 									items: [
// 										...entry.items,
// 										...products.map((product) => ({
// 											product,
// 											discountPrice: "",
// 											discountPercentage: "",
// 										})),
// 									],
// 								}
// 								: entry;
// 						}

// 						// If addMoreTestIndex is null/undefined, add to all entries
// 						return {
// 							...entry,
// 							items: [
// 								...entry.items,
// 								...products.map((product) => ({
// 									product,
// 									discountPrice: "",
// 									discountPercentage: "",
// 								})),
// 							],
// 						};
// 					})
// 					: [
// 						// If orderData is empty or undefined, create a new entry
// 						{
// 							items: products.map((product) => ({
// 								product,
// 								discountPrice: "",
// 								discountPercentage: "",
// 							})),
// 						},
// 					],
// 		};

// 		setOrder(updatedOrder);
// 		setAddMoreTestIndex();
// 	};

// 	// Add new member object in the orderData
// 	const addANewMember = () => {
// 		if (order.orderData.length === 0) return;

// 		const firstObject = order.orderData[0];

// 		const filteredItems = firstObject.items.filter(
// 			(item) => item.product && Object.keys(item.product).length > 0
// 		);

// 		const newObject = { patient: {}, items: [...filteredItems] };

// 		const updatedOrder = {
// 			...order,
// 			orderData: [...order.orderData, newObject],
// 		};

// 		setOrder(updatedOrder);
// 	};

// 	// Remove product by id in orderData
// 	const removeProductById = (productId) => {
// 		const updatedOrder = {
// 			...order,
// 			orderData: order.orderData.map((entry) => ({
// 				...entry,
// 				items: entry.items.filter((item) => item?.product?._id !== productId),
// 			})),
// 		};

// 		setOrder(updatedOrder);
// 	};

// 	// Remove multiple products by their IDs in orderData
// 	const removeProductsById = (productIds) => {
// 		if (!Array.isArray(productIds) || productIds.length === 0) {
// 			return;
// 		}
// 		const updatedOrder = {
// 			...order,
// 			orderData: order.orderData.map((entry) => ({
// 				...entry,
// 				items: entry.items.filter(
// 					(item) => !productIds.includes(item?.product?._id)
// 				),
// 			})),
// 		};

// 		setOrder(updatedOrder);
// 	};

// 	// Add patient/member to the correct index on orderData
// 	const updatePatientAtIndex = (patient) => {
// 		const updatedOrder = {
// 			...order,
// 			orderData: order.orderData.map((entry, i) =>
// 				i === indexToAddPatient
// 					? {
// 						...entry,
// 						patient: { ...entry.patient, ...patient },
// 					}
// 					: entry
// 			),
// 		};

// 		setOrder(updatedOrder);
// 		setIsAddMemberPopup(false);
// 	};

// 	// Remove patient/member from the correct index on orderData
// 	const removePatientAtIndex = (index) => {
// 		const updatedOrder = {
// 			...order,
// 			orderData: order.orderData.map((entry, i) =>
// 				i === index
// 					? {
// 						...entry,
// 						patient: {},
// 					}
// 					: entry
// 			),
// 		};

// 		setOrder(updatedOrder);
// 	};

// 	// Remove specific product from orderData
// 	// const removeSpecificProduct = (orderDataIndex, itemIndex) => {
// 	// 	const updatedOrder = {
// 	// 		...order,
// 	// 		orderData: order.orderData.map((entry, i) =>
// 	// 			i === orderDataIndex
// 	// 				? {
// 	// 					...entry,
// 	// 					items: entry.items.filter((_, idx) => idx !== itemIndex),
// 	// 				}
// 	// 				: entry
// 	// 		),
// 	// 	};

// 	// 	setOrder(updatedOrder);
// 	// };


// 	// remove specific product from cart and only one selection in home and visit date and time
// 	const removeSpecificProduct = (orderDataIndex, itemIndex) => {
// 		const updatedOrderData = order.orderData.map((entry, i) =>
// 			i === orderDataIndex
// 				? {
// 					...entry,
// 					items: entry.items.filter((_, idx) => idx !== itemIndex),
// 				}
// 				: entry
// 		);

// 		const hasRadiology = updatedOrderData?.some((orderItem) =>
// 			orderItem.items.some((item) => item.product?.productType === "Radiology")
// 		);

// 		const hasOtherThanRadiology = updatedOrderData?.some((orderItem) =>
// 			orderItem.items.some((item) => item.product?.productType !== "Radiology")
// 		);

// 		let resetFields = {};
// 		//  If Radiology removed and only Other tests left → reset Visit
// 		if (!hasRadiology && hasOtherThanRadiology) {
// 			resetFields = { visitDate: { date: {}, time: "" } };
// 		}
// 		//  If only Radiology left → reset Home
// 		else if (hasRadiology && !hasOtherThanRadiology) {
// 			resetFields = { collectionDate: { date: {}, time: "" } };
// 		}
// 		//  If cart is empty → reset both
// 		else if (!hasRadiology && !hasOtherThanRadiology) {
// 			resetFields = { visitDate: { date: {}, time: "" }, collectionDate: { date: {}, time: "" } };
// 		}

// 		const updatedOrder = {
// 			...order,
// 			orderData: updatedOrderData,
// 			...resetFields, // apply reset depending on condition
// 		};

// 		setOrder(updatedOrder);
// 	};

// 	// Count all the products available in cart
// 	const isEmpty = (obj) => Object.keys(obj).length === 0;
// 	const countAllCartProducts = () =>
// 		order?.orderData?.reduce(
// 			(count, order) =>
// 				count + order.items.filter((item) => !isEmpty(item.product)).length,
// 			0
// 		);



// 	// Add address to order
// 	// const updateAddress = async (newAddress) => {
// 	// 	if (order.orderData[0].items[0].product.brandName === "Redcliffe Labs") {
// 	// 		// console.log("Redcliffe Labs address update");
// 	// 		try {
// 	// 			const response = await axios.post(
// 	// 				`${baseUrl}/api/labs/get-redcliffe-location-status`,
// 	// 				{
// 	// 					place_query: newAddress.area,
// 	// 				}
// 	// 			);

// 	// 			console.log("Redcliffe location status:", response.data);

// 	// 			// You might use this response to update order
// 	// 			const updatedOrder = {
// 	// 				...order,
// 	// 				address: { ...newAddress },
// 	// 				geoLocation: {
// 	// 					latitude: response.data.coordinates.latitude || "",
// 	// 					longitude: response.data.coordinates.longitude || "",
// 	// 				},
// 	// 			};
// 	// 			setOrder(updatedOrder);
// 	// 			setServiceableArea({
// 	// 				flag: true,
// 	// 				message: `The area with pincode is serviceable for Redcliffe Labs.`,
// 	// 			});
// 	// 		} catch (error) {
// 	// 			const updatedOrder = {
// 	// 				...order,
// 	// 				address: { ...newAddress },
// 	// 			};
// 	// 			setOrder(updatedOrder);
// 	// 			setServiceableArea({
// 	// 				flag: false,
// 	// 				message: `The area with pincode is not serviceable for Redcliffe Labs.`,
// 	// 			});
// 	// 			setIsCollectionMethodPopup(true);
// 	// 			setIsAddAddressPopup(false);
// 	// 		}
// 	// 	} else {
// 	// 		const updatedOrder = {
// 	// 			...order,
// 	// 			address: { ...newAddress },
// 	// 		};
// 	// 		setOrder(updatedOrder);
// 	// 		handleServiceableArea(updatedOrder);
// 	// 	}

// 	// 	setIsCollectionMethodPopup(true);
// 	// 	setIsAddAddressPopup(false);
// 	// };


// 	const updateAddress = (newAddress) => {
// 		const updatedOrder = {
// 			...order,
// 			address: { ...newAddress },
// 		};

// 		//  Keep geoLocation only if already set by user
// 		if (order.geoLocation?.latitude && order.geoLocation?.longitude) {
// 			updatedOrder.geoLocation = {
// 				latitude: order.geoLocation.latitude,
// 				longitude: order.geoLocation.longitude,
// 			};
// 		}

// 		setOrder(updatedOrder);

// 		// Run your existing serviceability check (if needed)
// 		handleServiceableArea(updatedOrder);

// 		setIsCollectionMethodPopup(true);
// 		setIsAddAddressPopup(false);
// 	};



// 	// Remove address from order
// 	// const removeAddress = () => {
// 	// 	const updatedOrder = {
// 	// 		...order,
// 	// 		address: {},
// 	// 		collectionDate: { date: {}, time: "" }, // Clear collection date and time
// 	// 		visitDate: { date: {}, time: "" }, // Clear visit date and time
// 	// 		visitCenter: "", // Clear visit center
// 	// 		collectionType: "", // Reset collection type (add to your order state if you store it here)
// 	// 	};

// 	// 	setOrder(updatedOrder);
// 	// };

// 	const removeAddress = () => {
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			// Wipe the address completely
// 			address: {},
// 			// Wipe home collection details
// 			collectionDate: {
// 				date: {},
// 				time: "",
// 				slotId: undefined, // Or null, if you use that, to clear Redcliffe slot id
// 			},
// 			// Wipe visit center details
// 			visitDate: {
// 				date: {},
// 				time: "",
// 			},
// 			visitCenter: "",
// 			centerCode: "", // if you have it
// 			collectionType: "", // if you use this in your order state
// 			geoLocation: { latitude: "", longitude: "" }, // optional, if geolocation is used
// 		}));

// 		// Additionally, clear related app state if needed:
// 		setServiceableArea({ flag: null, message: "" }); // if you use this
// 		setCentreAvailable({ flag: null, message: "" }); // if you use this
// 		setAllCentres([]); // if you fetch centers for location

// 		// Close popups/modals as needed:
// 		setIsAddAddressPopup(false);
// 		setIsCollectionMethodPopup(false);
// 	};

// 	// Save user's current location - longitude and latitude
// 	// const saveCurrentLocation = () => {
// 	// 	return new Promise((resolve, reject) => {
// 	// 		if (!navigator.geolocation) {
// 	// 			const error = "Geolocation is not supported by your browser.";
// 	// 			console.error(error);
// 	// 			return reject(new Error(error));
// 	// 		}

// 	// 		navigator.geolocation.getCurrentPosition(
// 	// 			(position) => {
// 	// 				const { latitude, longitude } = position.coords;

// 	// 				const updatedOrder = {
// 	// 					...order,
// 	// 					geoLocation: { latitude, longitude },
// 	// 				};

// 	// 				setOrder(updatedOrder);
// 	// 				setUserLocation({ latitude, longitude });

// 	// 				// Resolve with location object
// 	// 				resolve({ latitude, longitude });
// 	// 			},
// 	// 			(err) => {
// 	// 				console.error("Error getting location:", err.message);
// 	// 				reject(err);
// 	// 			},
// 	// 			{
// 	// 				enableHighAccuracy: true,
// 	// 				timeout: 10000,
// 	// 				maximumAge: 0,
// 	// 			}
// 	// 		);
// 	// 	});
// 	// };
// 	// ---------------original code end------------------

// 	const saveCurrentLocation = () => {
// 		return new Promise((resolve, reject) => {
// 			if (!navigator.geolocation) {
// 				alert("Geolocation is not supported by your browser.");
// 				return reject(new Error("Geolocation not supported"));
// 			}

// 			navigator.geolocation.getCurrentPosition(
// 				(position) => {
// 					const { latitude, longitude } = position.coords;
// 					setOrder((prev) => ({ ...prev, geoLocation: { latitude, longitude } }));
// 					setUserLocation({ latitude, longitude });
// 					resolve({ latitude, longitude });
// 				},
// 				(err) => {
// 					if (err.code === 1) {
// 						// Permission denied
// 						alert(
// 							" Location permission denied.\n\n" +
// 							" Please enable location access manually:\n" +
// 							"- Click the lock icon 🔒 in the address bar\n" +
// 							"- Set Location to Allow\n" +
// 							"- Reload the page"
// 						);

// 					} else {
// 						alert("Error getting location: " + err.message);
// 						reject(err);
// 					}
// 				},
// 				{ enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
// 			);
// 		});

// 	};

// 	// Check if pincode is serviceable of not
// 	// const handleServiceableArea = useCallback(
// 	// 	async (updatedOrder = order) => {
// 	// 		const brandName =
// 	// 			updatedOrder?.orderData[0]?.items[0]?.product?.brandName;
// 	// 		const pincode = updatedOrder?.address?.pincode;

// 	// 		// Ensure brandName and pincode are available
// 	// 		if (!brandName || !pincode) {
// 	// 			console.error("Brand name or pincode is missing.");
// 	// 			return;
// 	// 		}

// 	// 		if (brandName === "Redcliffe Labs") {
// 	// 		} else {
// 	// 			try {
// 	// 				const url = `${baseUrl}/api/orders/serviceable-area`;

// 	// 				// Send POST request to check if the area is serviceable
// 	// 				let response;

// 	// 				if (brandName === "Dr Lal PathLabs") {
// 	// 					response = await axios.post(url, {
// 	// 						brandName,
// 	// 						pincode,
// 	// 						city: updatedOrder?.address?.city,
// 	// 						state: updatedOrder?.address?.state,
// 	// 					});
// 	// 				} else {
// 	// 					const response = await axios.post(url, { brandName, pincode });
// 	// 				}

// 	// 				setServiceableArea({
// 	// 					flag: response?.data?.success,
// 	// 					message: response?.data?.message,
// 	// 				});
// 	// 			} catch (error) {
// 	// 				console.error("Error while getting serviceable area:", error);
// 	// 			}
// 	// 		}
// 	// 	},
// 	// 	[baseUrl, order]
// 	// );
// 	// ------------some update----------------------
// 	const handleServiceableArea = useCallback(
// 		async (updatedOrder = order) => {
// 			const brandName =
// 				updatedOrder?.orderData[0]?.items[0]?.product?.brandName;
// 			const pincode = updatedOrder?.address?.pincode;

// 			if (!brandName || !pincode) {
// 				console.error("Brand name or pincode is missing.");
// 				return;
// 			}

// 			if (brandName === "Redcliffe Labs") {
// 				// skip or handle differently
// 				return;
// 			}

// 			try {
// 				const url = `${baseUrl}/api/orders/serviceable-area`;
// 				let response;

// 				if (brandName === "Dr Lal PathLabs") {
// 					response = await axios.post(url, {
// 						brandName,
// 						pincode,
// 						city: updatedOrder?.address?.city,
// 						state: updatedOrder?.address?.state,
// 					});
// 				} else {
// 					//don't redeclare with const
// 					response = await axios.post(url, { brandName, pincode });
// 				}

// 				// //  use .data.flag not .data.success
// 				setServiceableArea({
// 					flag: response?.data?.flag ?? true,
// 					message: response?.data?.message ?? "",
// 				});

// 				// setServiceableArea({
// 				// 	flag: response?.data?.success ?? false,  // use success from backend
// 				// 	message: response?.data?.message ?? "",
// 				// });

// 			} catch (error) {
// 				console.error("Error while getting serviceable area:", error);
// 				setServiceableArea({ flag: false, message: "Unable to check area." });
// 			}
// 		},
// 		[baseUrl, order]
// 	);

// 	// -----------------old once
// 	// // Save center in visitCenter
// 	// const saveVisitCenter = (getCenter) => {
// 	// 	setOrder((prevOrder) => ({
// 	// 		...prevOrder,
// 	// 		visitCenter: getCenter?.address,
// 	// 		centerCode: getCenter?.code,
// 	// 	}));
// 	// };

// 	// // Save date in collectionDate
// 	// const saveCollectionDate = (dateObject) => {
// 	// 	const updatedOrder = {
// 	// 		...order,
// 	// 		collectionDate: {
// 	// 			...order.collectionDate,
// 	// 			date: dateObject,
// 	// 		},
// 	// 	};

// 	// 	setOrder(updatedOrder);
// 	// };

// 	// // Save time in collectionDate
// 	// const saveCollectionTime = (timeString, id = 0) => {
// 	// 	// Validate that the input is a string
// 	// 	if (typeof timeString !== "string") {
// 	// 		console.error("Time must be a string.");
// 	// 		return;
// 	// 	}

// 	// 	if (order.orderData[0].items[0].product.brandName === "Redcliffe Labs") {
// 	// 		const updatedOrder = {
// 	// 			...order,
// 	// 			collectionDate: {
// 	// 				...order.collectionDate,
// 	// 				time: timeString,
// 	// 				slotId: id,
// 	// 			},
// 	// 		};
// 	// 		setOrder(updatedOrder);
// 	// 	} else {
// 	// 		const updatedOrder = {
// 	// 			...order,
// 	// 			collectionDate: {
// 	// 				...order.collectionDate,
// 	// 				time: timeString,
// 	// 			},
// 	// 		};

// 	// 		setOrder(updatedOrder);
// 	// 	}
// 	// };

// 	// // Save date in collectionDate
// 	// const saveVisitDate = (dateObject) => {
// 	// 	const updatedOrder = {
// 	// 		...order,
// 	// 		visitDate: {
// 	// 			...order.visitDate,
// 	// 			date: dateObject,
// 	// 		},
// 	// 	};

// 	// 	setOrder(updatedOrder);
// 	// };

// 	// // Save time in collectionDate
// 	// const saveVisitTime = (timeString) => {
// 	// 	// Validate that the input is a string
// 	// 	if (typeof timeString !== "string") {
// 	// 		console.error("Time must be a string.");
// 	// 		return;
// 	// 	}

// 	// 	const updatedOrder = {
// 	// 		...order,
// 	// 		visitDate: {
// 	// 			...order.visitDate,
// 	// 			time: timeString,
// 	// 		},
// 	// 	};

// 	// 	setOrder(updatedOrder);
// 	// };

// 	// -----------------------ending old once-------------------


// 	// Checking if any productType is Radiology
// 	const hasRadiology = order?.orderData?.some((orderItem) =>
// 		orderItem.items.some((item) => item.product?.productType === "Radiology")
// 	);

// 	//Check if any productType other thatn Radiology
// 	const hasOtherThanRadiology = order?.orderData?.some((orderItem) =>
// 		orderItem.items.some((item) => item.product?.productType !== "Radiology")
// 	);

// 	const isChangeMethodVisible = hasRadiology && hasOtherThanRadiology;

// 	// Save center in visitCenter (unchanged)
// 	const saveVisitCenter = (getCenter) => {
// 		setOrder((prev) => ({
// 			...prev,
// 			visitCenter: getCenter?.address,
// 			centerCode: getCenter?.code,
// 		}));
// 	};

// 	// Save date in collectionDate (Home Collection)
// 	const saveCollectionDate = (dateObject) => {
// 		setOrder((prev) => {
// 			const next = {
// 				...prev,
// 				collectionDate: {
// 					...prev.collectionDate,
// 					date: dateObject,
// 				},
// 			};
// 			// Reset Visit only if "Change method" is NOT visible
// 			if (!isChangeMethodVisible) {
// 				next.visitDate = { date: {}, time: "" };
// 			}
// 			return next;
// 		});
// 	};

// 	// Save time in collectionDate (Home Collection)
// 	const saveCollectionTime = (timeString, id = 0) => {
// 		if (typeof timeString !== "string") {
// 			console.error("Time must be a string.");
// 			return;
// 		}

// 		setOrder((prev) => {
// 			const isRedcliffe =
// 				prev.orderData?.[0]?.items?.[0]?.product?.brandName === "Redcliffe Labs";

// 			const next = {
// 				...prev,
// 				collectionDate: {
// 					...prev.collectionDate,
// 					time: timeString,
// 					...(isRedcliffe ? { slotId: id } : {}),
// 				},
// 			};
// 			// Reset Visit only if "Change method" is NOT visible
// 			if (!isChangeMethodVisible) {
// 				next.visitDate = { date: {}, time: "" };
// 			}
// 			return next;
// 		});
// 	};

// 	// Save date in visitDate (Visit Nearest Center)
// 	const saveVisitDate = (dateObject) => {
// 		setOrder((prev) => {
// 			const next = {
// 				...prev,
// 				visitDate: {
// 					...prev.visitDate,
// 					date: dateObject,
// 				},
// 			};
// 			// Reset Home only if "Change method" is NOT visible
// 			if (!isChangeMethodVisible) {
// 				next.collectionDate = { date: {}, time: "" };
// 			}
// 			return next;
// 		});
// 	};

// 	// Save time in visitDate (Visit Nearest Center)
// 	const saveVisitTime = (timeString) => {
// 		if (typeof timeString !== "string") {
// 			console.error("Time must be a string.");
// 			return;
// 		}

// 		setOrder((prev) => {
// 			const next = {
// 				...prev,
// 				visitDate: {
// 					...prev.visitDate,
// 					time: timeString,
// 				},
// 			};
// 			// Reset Home only if "Change method" is NOT visible
// 			if (!isChangeMethodVisible) {
// 				next.collectionDate = { date: {}, time: "" };
// 			}
// 			return next;
// 		});
// 	};

// 	// const saveVisitDate = (dateObject) => {
// 	// 	setOrder((prev) => ({
// 	// 		...prev,
// 	// 		visitDate: {
// 	// 			...prev.visitDate,
// 	// 			date: dateObject,
// 	// 			time: "" // reset time if new date picked
// 	// 		},
// 	// 		collectionDate: { date: {}, time: "" } // always reset home collection
// 	// 	}));
// 	// };

// 	// const saveVisitTime = (timeString) => {
// 	// 	if (typeof timeString !== "string") {
// 	// 		console.error("Time must be a string.");
// 	// 		return;
// 	// 	}

// 	// 	setOrder((prev) => ({
// 	// 		...prev,
// 	// 		visitDate: {
// 	// 			...prev.visitDate,
// 	// 			time: timeString,
// 	// 		},
// 	// 		collectionDate: { date: {}, time: "" } // always reset home collection
// 	// 	}));
// 	// };

// 	// const saveCollectionDate = (dateObject) => {
// 	// 	setOrder((prev) => ({
// 	// 		...prev,
// 	// 		collectionDate: {
// 	// 			...prev.collectionDate,
// 	// 			date: dateObject,
// 	// 			time: "" // reset time if new date picked
// 	// 		},
// 	// 		visitDate: { date: {}, time: "" } // always reset visit
// 	// 	}));
// 	// };

// 	// const saveCollectionTime = (timeString, id = 0) => {
// 	// 	if (typeof timeString !== "string") {
// 	// 		console.error("Time must be a string.");
// 	// 		return;
// 	// 	}

// 	// 	setOrder((prev) => {
// 	// 		const isRedcliffe =
// 	// 			prev.orderData?.[0]?.items?.[0]?.product?.brandName === "Redcliffe Labs";

// 	// 		return {
// 	// 			...prev,
// 	// 			collectionDate: {
// 	// 				...prev.collectionDate,
// 	// 				time: timeString,
// 	// 				...(isRedcliffe ? { slotId: id } : {}),
// 	// 			},
// 	// 			visitDate: { date: {}, time: "" } // always reset visit
// 	// 		};
// 	// 	});
// 	// };


// 	// Calculate all prices according to products added
// 	const calculateTotalPrice = useCallback(
// 		async (orderDataToCalculate, promoCode) => {
// 			try {
// 				// Get the token and userId from cookies
// 				const token = Cookies.get("token");
// 				//const userId = Cookies.get("userId");

// 				// Check if token exists
// 				if (!token) {
// 					throw new Error("User is not authenticated");
// 				}

// 				// Set the Authorization header with the token
// 				const config = {
// 					headers: {
// 						Authorization: `Bearer ${token}`,
// 					},
// 				};

// 				// Send POST request to calculate the total price
// 				const response = await axios.post(
// 					`${baseUrl}/api/cart/calculate-total-price`,
// 					{ orderDataToCalculate, promoCode },
// 					config
// 				);

// 				// Handle the response (display or use totalPrice)
// 				if (response?.data?.success) {
// 					setOrderSummary(response?.data);
// 				} else {
// 					console.error("Error:", response?.data?.message);
// 				}
// 			} catch (error) {
// 				console.error("Error calculating total price:", error?.message);
// 			}
// 		},
// 		[baseUrl]
// 	);

// 	useEffect(() => {
// 		if (order?.orderData?.length > 0) {
// 			calculateTotalPrice(order?.orderData, order?.appliedPromoCode);
// 		}
// 	}, [order?.orderData]);

// 	// Apply promo code on order
// 	const handleApplyPromoCode = useCallback(async () => {
// 		try {
// 			const token = Cookies.get("token");
// 			const orderDataToApplyPromoCode = {
// 				orders: order?.orderData,
// 				collectionCharges: order?.paymentDetails.collectionCharges,
// 			};

// 			if (!promoCode || !order) {
// 				setPromoCodeMessage({
// 					flag: false,
// 					message: "Please provide a promo code and order details.",
// 				});
// 				return;
// 			}

// 			const config = {
// 				headers: {
// 					Authorization: `Bearer ${token}`,
// 				},
// 			};

// 			const response = await axios.post(
// 				`${baseUrl}/api/cart/apply-promocode`,
// 				{ promoCode, orderDataToApplyPromoCode },
// 				config
// 			);

// 			if (response.data.success) {
// 				setOrder((prevOrder) => ({
// 					...prevOrder,
// 					orderData: response.data.updatedOrderData,
// 					appliedPromoCode: promoCode,
// 					paymentDetails: {
// 						...prevOrder.paymentDetails,
// 						discount: response.data.totalDiscount,
// 						collectionCharges: response.data.collectionCharges,
// 					},
// 				}));

// 				if (promoCode === "FREEHOME") {
// 					setPromoCodeMessage({
// 						flag: true,
// 						message: `Promo code applied successfully. You saved ₹100 on your home collection fee`,
// 					});
// 				} else {
// 					setPromoCodeMessage({
// 						flag: true,
// 						message: `Promo code applied successfully. You saved ₹${response.data.totalDiscount}!`,
// 					});
// 				}
// 				setIsPromoCode(false);
// 			} else {
// 				setPromoCodeMessage({
// 					flag: false,
// 					message: response?.data?.message || "Failed to apply promo code.",
// 				});
// 				if (order?.appliedPromoCode?.length > 0) {
// 					removePromoCode();
// 					setPromoCodeMessage({
// 						flag: null,
// 						message: "",
// 					});
// 				}
// 			}
// 		} catch (error) {
// 			console.error("Error applying promo code:", error);

// 			setPromoCodeMessage({
// 				flag: false,
// 				message:
// 					error?.response?.data?.message ||
// 					"An error occurred while applying the promo code. Please try again.",
// 			});
// 			if (order?.appliedPromoCode?.length > 0) {
// 				removePromoCode();
// 				setPromoCodeMessage({
// 					flag: null,
// 					message: "",
// 				});
// 			}
// 		}
// 	}, [baseUrl, promoCode, order?.orderData]);

// 	const removePromoCode = () => {
// 		setPromoCode("");
// 		setOrder((prevOrder) => ({
// 			...prevOrder,
// 			appliedPromoCode: "",
// 			orderData: prevOrder.orderData.map((order) => ({
// 				...order,
// 				items: order.items.map((item) => ({
// 					...item,
// 					discountPrice: "",
// 					discountPercentage: "",
// 				})),
// 			})),
// 			paymentDetails: {
// 				...prevOrder.paymentDetails,
// 				discount: "",
// 				totalDiscountPrice: "",
// 				collectionCharges: 100.0,
// 			},
// 		}));
// 	};

// 	// Populate `userDetails` dynamically
// 	useEffect(() => {
// 		if (userProfile) {
// 			console.log("UserProfile in useEffect:", userProfile);
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				userDetails: {
// 					name: userProfile?.name || "",
// 					contact: userProfile?.contact || "",
// 					email: userProfile?.email || "",
// 				},
// 			}));
// 		}
// 	}, [userProfile]);

// // 	useEffect(() => {
// // 	if (userProfile) {
// // 		setOrder((prevOrder) => ({
// // 			...prevOrder,
// // 			userDetails: {
// // 				name: userProfile?.name || prevOrder.userDetails.name || "",
// // 				contact: userProfile?.contact || prevOrder.userDetails.contact || "",
// // 				email: userProfile?.email || prevOrder.userDetails.email || "",
// // 			},
// // 		}));
// // 	}
// // }, [userProfile]);

// 	console.log("UserProfile in useEffect:", userProfile);
// console.log("Order.userDetails before save:", order.userDetails);
// // console.log("LocalStorage finelabsOrder:", localStorage.getItem("finelabsOrder"));


// 	// Populate `paymentDetails` dynamically
// 	useEffect(() => {
// 		// Only update if `orderSummary` has valid data
// 		if (orderSummary?.success) {
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				paymentDetails: {
// 					currency: orderSummary.currency,
// 					totalPrice: orderSummary.totalPrice,
// 					totalDiscountPrice: orderSummary.totalDiscountPrice,
// 					finalAmount: orderSummary.finalAmount,
// 					collectionCharges: orderSummary.collectionCharges,
// 					freeChargeDifference: orderSummary.freeChargeDifference,
// 					discount: orderSummary.discount,
// 					platformFee: orderSummary.platformFee,
// 				},
// 			}));
// 		}
// 	}, [orderSummary]);

// 	// Remove object from orderData it items array is empty
// 	useEffect(() => {
// 		const cleanOrderData = () => {
// 			setOrder((prevOrder) => {
// 				const cleanedOrderData = prevOrder.orderData.filter(
// 					(data) => data.items && data.items.length > 0
// 				);

// 				// Update the state only if the data was cleaned
// 				if (cleanedOrderData.length !== prevOrder.orderData.length) {
// 					return { ...prevOrder, orderData: cleanedOrderData };
// 				}
// 				return prevOrder;
// 			});
// 		};

// 		if (order?.orderData?.length > 0) {
// 			cleanOrderData();
// 		}
// 	}, [order?.orderData]);

// 	const getRedcliffeLabsTimeSlots = async (collectionDate) => {
// 		try {
// 			const response = await axios.post(
// 				`${baseUrl}/api/labs/get-redcliffe-time-slots`,
// 				{
// 					collectionDate,
// 					latitude: order.geoLocation.latitude,
// 					longitude: order.geoLocation.longitude,
// 				}
// 			);

// 			return response.data.results; // Should be the `items` array returned by the backend
// 		} catch (error) {
// 			console.error(
// 				"Error calling backend to get Redcliffe Labs time slots:",
// 				error
// 			);
// 			throw error;
// 		}
// 	};


// 	const createRedcliffeLabsTemporaryOrder = async (order) => {
// 		try {
// 			const response = await axios.post(
// 				// `${baseUrl}/api/labs/create-redcliffe-temporary-order`,
// 				`${baseUrl}/api/labs/create-order`,
// 				{
// 					order,
// 				}
// 			);
// 			console.log(response.data, "Redcliffe Labs temporary order response");
// 			return response.data;
// 		} catch (error) {
// 			console.error("Error creating Redcliffe Labs temporary order:", error);
// 			throw error;
// 		}
// 	};

// 	const createRedcliffeLabsPermanentOrder = async (bookingId) => {
// 		// try {
// 		// 	const response = await axios.post(
// 		// 		`${baseUrl}/api/labs/create-redcliffe-permanent-order`,
// 		// 		{
// 		// 			bookingId,
// 		// 		}
// 		// 	);
// 		// 	console.log(response.data, "Redcliffe Labs permanent order response");
// 		// 	return response.data;
// 		// } catch (error) {
// 		// 	console.error("Error creating Redcliffe Labs permanent order:", error);
// 		// 	throw error;
// 		// }
// 	};

// 	// Create an order-(handleCreateOrder)-----------old once-----------------
// 	// const handleCreateOrder = useCallback(async () => {
// 	// 	try {
// 	// 		console.log("OrderProcessing context, line 1294 handleCreateOrder");
// 	// 		const url = `${baseUrl}/api/create-order`;
// 	// 		const data = {
// 	// 			amount: Math.round(parseFloat(orderSummary?.finalAmount) * 100),
// 	// 			currency,
// 	// 			receipt,
// 	// 		};

// 	// 		const response = await axios.post(url, data, {
// 	// 			headers: {
// 	// 				"Content-Type": "application/json",
// 	// 			},
// 	// 		});

// 	// 		if (response?.data?.success) {
// 	// 			const createOrderDataResponse = response?.data?.createOrderData;

// 	// 			// Open Razorpay payment window
// 	// 			const options = {
// 	// 				key: "rzp_test_bndj2YHgGFUarQ",
// 	// 				// key: "rzp_live_mlO20lt64Wtvpj",
// 	// 				amount: createOrderDataResponse?.amount,
// 	// 				currency: createOrderDataResponse?.currency,
// 	// 				name: "Fine Labs",
// 	// 				description: "Order Payment",
// 	// 				image: "/assets/finelabs-logo-rp.png",
// 	// 				order_id: createOrderDataResponse?.id, // Razorpay order ID
// 	// 				handler: function (paymentResponse) {
// 	// 					// Handle successful payment
// 	// 					setOrder((prevOrder) => ({
// 	// 						...prevOrder,
// 	// 						orderId: createOrderDataResponse?.id,
// 	// 					}));
// 	// 					setIsPaymentDone(true);
// 	// 				},
// 	// 				prefill: {
// 	// 					name: userProfile?.name || "",
// 	// 					email: userProfile?.email || "",
// 	// 					contact: userProfile?.contact || "",
// 	// 				},
// 	// 				notes: {
// 	// 					address: "",
// 	// 				},
// 	// 				theme: {
// 	// 					color: "#F37254",
// 	// 				},
// 	// 			};

// 	// 			const razorpay = new window.Razorpay(options);

// 	// 			razorpay.on("payment.failed", function (response) {
// 	// 				console.error("Payment failed:", response.error);
// 	// 				// Handle payment failure
// 	// 			});

// 	// 			razorpay.open();
// 	// 		} else {
// 	// 			console.log("Order creation failed:", response?.data);
// 	// 		}
// 	// 	} catch (err) {
// 	// 		console.error(
// 	// 			"Failed to create order:",
// 	// 			err.response?.data || "Something went wrong"
// 	// 		);
// 	// 	}
// 	// }, [baseUrl, currency, receipt, orderSummary?.finalAmount]);




// 	// --------------new handleCreateOrder--------------


// 	const handleCreateOrder = useCallback(async () => {
// 		try {
// 			// console.log("OrderProcessing context → handleCreateOrder");

// 			const url = `${baseUrl}/api/create-order`;

// 			//  Check if order contains non-radiology products
// 			const hasNonRadiology = order?.orderData?.some((orderItem) =>
// 				orderItem.items.some((item) => item.product?.productType !== "Radiology")
// 			);



// 			//  Helper function to hit API
// 			const createOrderRequest = async (geoLocation = null) => {
// 				const data = {
// 					amount: Math.round(parseFloat(orderSummary?.finalAmount) * 100),
// 					currency,
// 					receipt,
// 					...(geoLocation && { geoLocation }), // include location only if present
// 				};

// 				// console.log(" Sending payload to BE:", data);

// 				const response = await axios.post(url, data, {
// 					headers: { "Content-Type": "application/json" },
// 				});

// 				if (response?.data?.success) {
// 					const createOrderDataResponse = response?.data?.createOrderData;

// 					//  Razorpay options
// 					const options = {
// 						key: "rzp_test_bndj2YHgGFUarQ",
// 						// key: "rzp_live_mlO20lt64Wtvpj",
// 						amount: createOrderDataResponse?.amount,
// 						currency: createOrderDataResponse?.currency,
// 						name: "Fine Labs",
// 						description: "Order Payment",
// 						image: "/assets/finelabs-logo-rp.png",
// 						order_id: createOrderDataResponse?.id,
// 						handler: function (paymentResponse) {
// 							setOrder((prevOrder) => ({
// 								...prevOrder,
// 								orderId: createOrderDataResponse?.id,
// 							}));
// 							setIsPaymentDone(true);
// 						},
// 						prefill: {
// 							name: userProfile?.name || "",
// 							email: userProfile?.email || "",
// 							contact: userProfile?.contact || "",
// 						},
// 						notes: { address: "" },
// 						theme: { color: "#F37254" },
// 					};

// 					const razorpay = new window.Razorpay(options);

// 					razorpay.on("payment.failed", function (response) {
// 						console.error(" Payment failed:", response.error);
// 					});

// 					razorpay.open();
// 				} else {
// 					console.error(" Order creation failed:", response?.data);
// 				}
// 			};
// 			//  If order contains non-radiology → get user location
// 			if (hasNonRadiology && navigator.geolocation) {
// 				navigator.geolocation.getCurrentPosition(
// 					async (position) => {
// 						const geoLocation = {
// 							latitude: position.coords.latitude,
// 							longitude: position.coords.longitude,
// 						};
// 						// console.log(" User Location (FE):", geoLocation);
// 						await createOrderRequest(geoLocation);
// 					},
// 					async (error) => {
// 						console.warn(" Location access denied:", error);
// 						await createOrderRequest(); // fallback without location
// 					}
// 				);
// 			} else {
// 				//  Radiology-only order → skip location
// 				await createOrderRequest();
// 			}

// 		} catch (err) {
// 			console.error(" Failed to create order:", err.response?.data || err.message);
// 		}
// 	}, [baseUrl, currency, receipt, orderSummary?.finalAmount, order, userProfile]);



// 	// ---------------previous one--------------------
// 	// Save created order
// 	// const createOrder = useCallback(async () => {
// 	// 	const url = `${baseUrl}/api/orders/create-order`;

// 	// 	const token = Cookies.get("token");
// 	// 	const userId = Cookies.get("userId");

// 	// 	// Check for missing authentication details
// 	// 	if (!token || !userId) {
// 	// 		console.error("Missing authentication details.");
// 	// 		return { success: false, message: "Authentication required." };
// 	// 	}

// 	// 	try {
// 	// 		const headers = {
// 	// 			Authorization: `Bearer ${token}`,
// 	// 			"Content-Type": "application/json",
// 	// 		};

// 	// 		let response;
// 	// 		// Send POST request to create order
// 	// 		if (order.orderData[0].items[0].product.brandName === "Redcliffe Labs") {
// 	// 			const tempOrder = await createRedcliffeLabsTemporaryOrder(order);
// 	// 			await createRedcliffeLabsPermanentOrder(tempOrder.booking_id);
// 	// 			response = await axios.post(
// 	// 				url,
// 	// 				{ ...order, userId, bookingId: tempOrder.booking_id },
// 	// 				{ headers }
// 	// 			);
// 	// 		} else {
// 	// 			response = await axios.post(url, { ...order, userId }, { headers });
// 	// 		}

// 	// 		if (response?.status == 201) {
// 	// 			setIsPaymentDone(false);
// 	// 			fetchOrders();
// 	// 			navigate("/payment/thank-you");
// 	// 			return response.data;
// 	// 		} else {
// 	// 			console.error("Failed to create order:", response.data.message);
// 	// 			return response.data;
// 	// 		}
// 	// 	} catch (error) {
// 	// 		console.error("Error creating order:", error.message);

// 	// 		return { success: false, message: error.message };
// 	// 	}
// 	// }, [order]);

// 	// ------------------------when order is create and payment is done so reset the state---------------------
// 	// const createOrder = useCallback(async () => {
// 	// 	console.log("createORder line 1412 in order processing context");
// 	// 	const url = `${baseUrl}/api/orders/create-order`;
// 	// 	const token = Cookies.get("token");
// 	// 	const userId = Cookies.get("userId");

// 	// 	if (!token || !userId) {
// 	// 		console.error("Missing authentication details.");
// 	// 		return { success: false, message: "Authentication required." };
// 	// 	}

// 	// 	try {
// 	// 		const headers = {
// 	// 			Authorization: `Bearer ${token}`,
// 	// 			"Content-Type": "application/json",
// 	// 		};

// 	// 		let response;
// 	// 		if (order.orderData[0]?.items[0]?.product?.brandName === "Redcliffe Labs") {
// 	// 			const tempOrder = await createRedcliffeLabsTemporaryOrder(order);
// 	// 			await createRedcliffeLabsPermanentOrder(tempOrder.booking_id);
// 	// 			response = await axios.post(
// 	// 				url,
// 	// 				{ ...order, userId, bookingId: tempOrder.booking_id },
// 	// 				{ headers }
// 	// 			);
// 	// 		} else {
// 	// 			response = await axios.post(url, { ...order, userId }, { headers });
// 	// 		}


// 	// 		if (response?.status === 201) {
// 	// 			setIsPaymentDone(false);
// 	// 			fetchOrders();

// 	// 			//  Reset order state & clear from localStorage
// 	// 			const emptyOrder = {
// 	// 				orderId: "",
// 	// 				userDetails: { name: "", contact: "", email: "" },
// 	// 				orderData: [],
// 	// 				address: {},
// 	// 				paymentDetails: {
// 	// 					currency: "₹",
// 	// 					totalPrice: "",
// 	// 					totalDiscountPrice: "",
// 	// 					finalAmount: "",
// 	// 					collectionCharges: "",
// 	// 					freeChargeDifference: "",
// 	// 					discount: "",
// 	// 					platformFee: "",
// 	// 				},
// 	// 				collectionMode: "",
// 	// 				visitCenter: "",
// 	// 				centerCode: "",
// 	// 				collectionDate: { date: {}, time: "" },
// 	// 				visitDate: { date: {}, time: "" },
// 	// 				geoLocation: { longitude: "", latitude: "" },
// 	// 				status: "Pending",
// 	// 				appliedPromoCode: "",
// 	// 			};

// 	// 			setOrder(emptyOrder);
// 	// 			localStorage.setItem("order", JSON.stringify(emptyOrder)); // keeps clean slate

// 	// 			navigate("/payment/thank-you");
// 	// 			return response.data;
// 	// 		} else {
// 	// 			console.error("Failed to create order:", response.data.message);
// 	// 			return response.data;
// 	// 		}
// 	// 	} catch (error) {
// 	// 		console.error("Error creating order:", error.message);
// 	// 		return { success: false, message: error.message };
// 	// 	}
// 	// }, [order]);



// 	// --------------create order with geolocation and reset order after submit order----------
// 	const createOrder = useCallback(async () => {
// 		console.log("createOrder line 1412 in order processing context");
// 		const url = `${baseUrl}/api/orders/create-order`;
// 		const token = Cookies.get("token");
// 		const userId = Cookies.get("userId");

// 		if (!token || !userId) {
// 			console.error("Missing authentication details.");
// 			return { success: false, message: "Authentication required." };
// 		}

// 		try {
// 			const headers = {
// 				Authorization: `Bearer ${token}`,
// 				"Content-Type": "application/json",
// 			};

// 			//  Check if any product is not Radiology
// 			const hasNonRadiology = order?.orderData?.some((orderItem) =>
// 				orderItem.items.some((item) => item.product?.productType !== "Radiology")
// 			);

// 			//  Function to send order to backend
// 			const sendOrderRequest = async (geoLocation = null, bookingId = null) => {
// 				let payload = { ...order, userId };

// 				if (bookingId) {
// 					payload.bookingId = bookingId;
// 				}

// 				// Attach geolocation if present
// 				if (geoLocation) {
// 					payload.geoLocation = geoLocation;
// 				}

// 				return axios.post(url, payload, { headers });
// 			};

// 			let response;
// 			// if (order.orderData[0]?.items[0]?.product?.brandName === "Redcliffe Labs" ) {
// 			// 	// Special case for Redcliffe Labs
// 			// 	const tempOrder = await createRedcliffeLabsTemporaryOrder(order);
// 			// 	await createRedcliffeLabsPermanentOrder(tempOrder.booking_id);

// 			// 	if (hasNonRadiology && navigator.geolocation) {
// 			// 		// Get location
// 			// 		await new Promise((resolve, reject) => {
// 			// 			navigator.geolocation.getCurrentPosition(
// 			// 				async (position) => {
// 			// 					const geoLocation = {
// 			// 						latitude: position.coords.latitude,
// 			// 						longitude: position.coords.longitude,
// 			// 					};
// 			// 					console.log(" User Location (FE):", geoLocation);
// 			// 					response = await sendOrderRequest(geoLocation, tempOrder.booking_id);
// 			// 					resolve();
// 			// 				},
// 			// 				async (error) => {
// 			// 					console.error("Location access denied:", error);
// 			// 					response = await sendOrderRequest(null, tempOrder.booking_id);
// 			// 					resolve();
// 			// 				}
// 			// 			);
// 			// 		});
// 			// 	} else {
// 			// 		response = await sendOrderRequest(null, tempOrder.booking_id);
// 			// 	}
// 			// } else {
// 			// 	// Normal case (not Redcliffe Labs)
// 			// 	if (hasNonRadiology && navigator.geolocation) {
// 			// 		await new Promise((resolve, reject) => {
// 			// 			navigator.geolocation.getCurrentPosition(
// 			// 				async (position) => {
// 			// 					const geoLocation = {
// 			// 						latitude: position.coords.latitude,
// 			// 						longitude: position.coords.longitude,
// 			// 					};
// 			// 					console.log(" User Location (FE):", geoLocation);
// 			// 					response = await sendOrderRequest(geoLocation);
// 			// 					resolve();
// 			// 				},
// 			// 				async (error) => {
// 			// 					console.error("Location access denied:", error);
// 			// 					response = await sendOrderRequest();
// 			// 					resolve();
// 			// 				}
// 			// 			);
// 			// 		});
// 			// 	} else {
// 			// 		response = await sendOrderRequest();
// 			// 	}
// 			// }

// 			if (hasNonRadiology && navigator.geolocation) {
// 				await new Promise((resolve, reject) => {
// 					navigator.geolocation.getCurrentPosition(
// 						async (position) => {
// 							const geoLocation = {
// 								latitude: position.coords.latitude,
// 								longitude: position.coords.longitude,
// 							};
// 							console.log(" User Location (FE):", geoLocation);
// 							response = await sendOrderRequest(geoLocation);
// 							resolve();
// 						},
// 						async (error) => {
// 							console.error("Location access denied:", error);
// 							response = await sendOrderRequest();
// 							resolve();
// 						}
// 					);
// 				});
// 			} else {
// 				response = await sendOrderRequest();
// 			}

// 			//  Handle response
// 			if (response?.status === 201) {
// 				setIsPaymentDone(false);
// 				fetchOrders();

// 				// Reset order state & clear from localStorage
// 				const emptyOrder = {
// 					orderId: "",
// 					userDetails: { name: "", contact: "", email: "" },
// 					orderData: [],
// 					address: {},
// 					paymentDetails: {
// 						currency: "₹",
// 						totalPrice: "",
// 						totalDiscountPrice: "",
// 						finalAmount: "",
// 						collectionCharges: "",
// 						freeChargeDifference: "",
// 						discount: "",
// 						platformFee: "",
// 					},
// 					collectionMode: "",
// 					visitCenter: "",
// 					centerCode: "",
// 					collectionDate: { date: {}, time: "" },
// 					visitDate: { date: {}, time: "" },
// 					geoLocation: { longitude: "", latitude: "" },
// 					status: "Pending",
// 					appliedPromoCode: "",
// 				};

// 				setOrder(emptyOrder);
// 				localStorage.setItem("order", JSON.stringify(emptyOrder));

// 				navigate("/payment/thank-you");
// 				return response.data;
// 			} else {
// 				console.error("Failed to create order:", response.data.message);
// 				return response.data;
// 			}
// 		} catch (error) {
// 			console.error("Error creating order:", error.message);
// 			return { success: false, message: error.message };
// 		}
// 	}, [order]);




// 	useEffect(() => {
// 		if (isPaymentDone) {
// 			createOrder();
// 		}
// 	}, [isPaymentDone]);

// 	// Fetch all user's orders
// 	const fetchOrders = useCallback(async () => {
// 		const token = Cookies.get("token");
// 		const userId = Cookies.get("userId");

// 		if (!token || !userId) {
// 			console.error("Authentication required. Missing token or userId.");
// 			return;
// 		}

// 		try {
// 			const headers = {
// 				Authorization: `Bearer ${token}`,
// 			};

// 			const response = await axios.get(`${baseUrl}/api/orders/get-order`, {
// 				params: { userId },
// 				headers,
// 			});

// 			if (response?.data?.success) {
// 				setAllOrders(response?.data?.orders);
// 			} else {
// 				console.error(response?.data?.message);
// 				return [];
// 			}
// 		} catch (error) {
// 			console.error("Error fetching orders:", error.message);
// 		}
// 	}, []);

// 	// Fetch centres by city and brandName
// 	const fetchCentresByCityAndBrand = async (brand = "", city = "") => {
// 		try {
// 			const url = `${baseUrl}/api/centre/centres/${brand}/${city}`;
// 			const response = await axios.get(url);
// 			if (response?.data?.success) {
// 				setAllCentres(response?.data?.centres);
// 			}
// 			console.log("Response", response);
// 		} catch (error) {
// 			console.error("Error fetching centres:", error);
// 		}
// 	};

// 	// const fetchCentresByCityAndBrandAndType = async (
// 	// 	brand = "",
// 	// 	city = "",
// 	// 	type = []
// 	// ) => {
// 	// 	try {
// 	// 		const url = `${baseUrl}/api/centre/centres/${brand}/${city}`;
// 	// 		const response = await axios.get(url, {
// 	// 			params: { type },
// 	// 		});
// 	// 		console.log(response.data, "-----------------Centres by city and brand response");
// 	// 		if (response?.data?.success) {
// 	// 			setCentreAvailable({ flag: true, message: response?.data?.message });
// 	// 			setAllCentres(response?.data?.centres);
// 	// 		} else {
// 	// 			setCentreAvailable({ flag: false, message: response?.data?.message });
// 	// 		}
// 	// 	} catch (error) {
// 	// 		console.error("Error fetching centres:", error);
// 	// 	}
// 	// };


// 	const fetchCentresByCityAndBrandAndType = async (
// 		brand = "",
// 		city = "",
// 		type = []
// 	) => {
// 		// console.log("Brand:", brand);
// 		// console.log("City:", city);
// 		// console.log("Type:", type);
// 		try {
// 			// Ensure no leading/trailing spaces and proper encoding
// 			const encodedBrand = encodeURIComponent(brand.trim());
// 			const encodedCity = encodeURIComponent(city.trim());

// 			const url = `${baseUrl}/api/centre/centres/${encodedBrand}/${encodedCity}`;
// 			// console.log("Fetching centres from URL:", url);
// 			// Send type only if not empty
// 			const params = type.length ? { type } : {};
// 			// console.log("line 1112:", encodedBrand, encodedCity);
// 			// console.log("Params:", params);
// 			const response = await axios.get(url, { params });

// 			// console.log(response.data, "----------------- Centres by city and brand response");

// 			if (response?.data?.success) {
// 				setCentreAvailable({ flag: true, message: response?.data?.message });
// 				setAllCentres(response?.data?.centres);
// 			} else {
// 				setCentreAvailable({ flag: false, message: response?.data?.message });
// 			}
// 		} catch (error) {
// 			console.error("Error fetching centres:", error);
// 		}
// 	};

// 	// Update collection type
// 	useEffect(() => {
// 		const updateCollectionType = () => {
// 			setOrder((prevOrder) => ({
// 				...prevOrder,
// 				collectionMode: collectionType,
// 			}));
// 		};

// 		updateCollectionType();
// 	}, [collectionType]);

// 	const handleCancelRedcliffeOrder = async (bookingId) => {
// 		try {
// 			const response = await axios.post(
// 				`${baseUrl}/api/labs/cancel-redcliffe-order`,
// 				{
// 					bookingId,
// 				}
// 			);
// 			console.log(response.data, "Redcliffe Labs cancel booking response");
// 			return response.data;
// 		} catch (error) {
// 			console.error("Error cancelling Redcliffe Labs booking:", error);
// 			throw error;
// 		}
// 	};

// 	return (
// 		<OrderProcessingContext.Provider
// 			value={{
// 				order,
// 				setOrder,
// 				addProductToCart,
// 				addANewMember,
// 				removeProductById,
// 				setIndexToAddPatient,
// 				updatePatientAtIndex,
// 				isAddMemberPopup,
// 				setIsAddMemberPopup,
// 				removePatientAtIndex,
// 				removeSpecificProduct,
// 				updateAddress,
// 				isAddAddressPopup,
// 				setIsAddAddressPopup,
// 				removeAddress,
// 				saveCurrentLocation,
// 				countAllCartProducts,
// 				serviceableArea,
// 				saveCollectionDate,
// 				saveCollectionTime,
// 				saveVisitDate,
// 				saveVisitTime,
// 				isPromoCode,
// 				setIsPromoCode,
// 				promoCode,
// 				setPromoCode,
// 				handleApplyPromoCode,
// 				promoCodeMessage,
// 				setPromoCodeMessage,
// 				handleCreateOrder,
// 				fetchOrders,
// 				allOrders,
// 				setAllOrders,
// 				removePromoCode,
// 				setAddMoreTestIndex,
// 				saveVisitCenter,
// 				fetchCentresByCityAndBrand,
// 				allCentres,
// 				collectionType,
// 				setCollectionType,
// 				isCollectionMethodPopup,
// 				setIsCollectionMethodPopup,
// 				addProductsToCart,
// 				removeProductsById,
// 				handleServiceableArea,
// 				getRedcliffeLabsTimeSlots,
// 				createRedcliffeLabsTemporaryOrder,
// 				handleCancelRedcliffeOrder,
// 				fetchCentresByCityAndBrandAndType,
// 				centreAvailable,
// 				setAllCentres,
// 				setCentreAvailable,
// 			}}>
// 			{children}
// 		</OrderProcessingContext.Provider>
// 	);
// };

// export const useOrderProcessingContext = () =>
// 	useContext(OrderProcessingContext);

// export default OrderProcessingProvider;

